(() => {

// NOTICE!! THIS IS REQUIRED TO MAKE YOUR NETO SHOPPING CART WORK
// DO NOT REMOVE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING
var $8b5bbe8eeb487c73$var$nCustom = {
    vars: {
        focused: $("body"),
        lastFocused: $("body")
    },
    funcs: {
        initPageFuncs: function() {
            // Ajax Wish List
            $.addToWishList({
                class: "wishlist_toggle",
                textclass: "wishlist_text",
                htmlon: '<svg><use xlink:href="#heart-light"></use></svg>',
                htmloff: '<svg><use xlink:href="#heart-solid"></use></svg>',
                tooltip_css: "whltooltips",
                imageon: "",
                imageoff: ""
            });
            // Ajax Add To Cart
            $.addToCartInit({
                cart_id: "cartcontents",
                target_id: "cartcontentsheader",
                image_rel: "itmimg"
            });
            // Renders the instant search results - edit design of ajax results here
            $.initSearchField({
                result_header: '<ul class="nav nav-list">',
                result_body: '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
                result_footer: "</ul>",
                category_header: '<ul class="nav nav-list">',
                category_body: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
                category_footer: "</ul>"
            });
        },
        // Capture the last item focused
        updateFocused: function() {
            $8b5bbe8eeb487c73$var$nCustom.vars.lastFocused = $8b5bbe8eeb487c73$var$nCustom.vars.focused;
        },
        // Place focus on popup
        popupFocus: function() {
            var popUp = document.getElementById("npopupDesc");
            // Configures the observer
            var config = {
                childList: true
            };
            // Create an observer instance
            var popUpObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    // Initial observer
                    if (mutation.addedNodes["0"]) {
                        $8b5bbe8eeb487c73$var$nCustom.funcs.updateFocused();
                        // focus on the popup
                        $(popUp).attr("tabindex", "-1").trigger("focus");
                    } else {
                        $(popUp).attr("tabindex", "").trigger("focus");
                        // Observer closing popup
                        $($8b5bbe8eeb487c73$var$nCustom.vars.lastFocused).trigger("focus");
                    }
                });
            });
            // Pass in the target node, as well as the observer options
            if (popUp) popUpObserver.observe(popUp, config);
        },
        buttonLoading: function() {
            var loadingText = $(this).attr("data-loading-text");
            var originalText = $(this).html();
            $(this).html(loadingText).addClass("disabled").prop("disabled", true);
            var pendingButton = this;
            setTimeout(function() {
                $(pendingButton).html(originalText).removeClass("disabled").prop("disabled", false);
            }, 3000);
        },
        windowPopup: function(url, width, height) {
            // Calculate the position of the popup so it’s centered on the screen.
            var left = screen.width / 2 - width / 2, top = screen.height / 2 - height / 2;
            window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
        },
        // Will remove/add class from element
        classToggle: function(element, css, type) {
            if (type) type == "add" ? $(element).addClass(css) : $(element).removeClass(css);
        }
    }
};
(function($1) {
    $1.extend({
        // For child product multi-add to cart function
        checkValidQty: function() {
            var found = 0;
            $1("#multiitemadd :input").each(function() {
                if ($1(this).attr("id").match(/^qty/)) {
                    if ($1(this).val() > 0) found = 1;
                }
            });
            if (found == 0) {
                $1.nPopupBox("Please specify a quantity before adding to cart");
                return false;
            }
            return true;
        },
        modQtyByMulti: function(obj, act) {
            var mul = 1;
            var maxm;
            var minm = 0;
            var objid = obj.replace(/^qty/, "");
            if ($1("#qty" + objid).length > 0) {
                if ($1("#multiplier_qty" + objid).length > 0) mul = $1("#multiplier_qty" + objid).val();
                if ($1("#min_qty" + objid).length > 0) minm = $1("#min_qty" + objid).val();
                if ($1("#max_qty" + objid).length > 0) maxm = $1("#max_qty" + objid).val();
                var cur = $1("#" + obj).val();
                if (isNaN(cur)) cur = 0;
                if (act == "add") {
                    cur = parseInt(cur) + parseInt(mul);
                    if (!isNaN(maxm) && cur > maxm) cur = maxm;
                } else if (act == "subtract") {
                    cur = parseInt(cur) - parseInt(mul);
                    if (cur < minm) cur = minm;
                }
                $1("#qty" + objid).val(cur);
            }
        },
        amend_total: function(ident) {
            var modifier = $1("#price" + ident).val();
            var obj = $1("#chk" + ident);
            var price = $1("#product_price").val();
            var newprice = 0;
            if (obj.is(":checked")) newprice = (price * 100 + modifier * 100) / 100;
            else newprice = (price * 100 - modifier * 100) / 100;
            $1("#product_price").val(newprice);
            $1(".prod-header__productprice, .updateproductpromo").html($1.formatCurrency(newprice));
            return true;
        }
    });
})(jQuery);
$(document).ready(function() {
    // Neto functionalty
    $8b5bbe8eeb487c73$var$nCustom.funcs.initPageFuncs();
    $8b5bbe8eeb487c73$var$nCustom.funcs.popupFocus();
    // Jquery Ui Date Picker
    $(".datepicker").datepicker({
        dateFormat: "dd/mm/yy"
    });
    // Carousel
    $(".carousel").carousel();
    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();
});
// Capture the current element the user focused in
$(document).on("focusin", function() {
    $8b5bbe8eeb487c73$var$nCustom.vars.focused = document.activeElement;
});
// Btn loading state
$(document).on("click", ".btn-loads", $8b5bbe8eeb487c73$var$nCustom.funcs.buttonLoading);
// Social media share
$(".js-social-share").on("click", function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.windowPopup($(this).attr("href"), 500, 300);
});
// Mobile menu
$(".nToggleMenu").on("click", function() {
    var toggleTarget = $(this).attr("data-target");
    $(toggleTarget).slideToggle();
});
// Invoice page
$("#cart_items").on("click", "[data-body-add]", function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.classToggle("body", $(this).attr("data-body-add"), "add");
});
$("#cart_items").on("click", "[data-body-remove]", function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.classToggle("body", $(this).attr("data-body-remove"), "remove");
});
$("#_jstl__buying_options").on("click", ".js-notifymodal-in-stock", function(e) {
    e.preventDefault();
    // Get values
    var sku = $(this).attr("data-sku");
    var $wrapper = $("#notifymodal .checkbox");
    var $terms = $("#notifymodal .terms_box");
    var $helpText = $("#notifymodal .checkbox .help-block");
    // Validate form
    if (!$.isChecked($terms)) {
        $wrapper.addClass("has-error");
        $helpText.removeClass("hidden");
        return false;
    } else {
        $wrapper.removeClass("has-error");
        $helpText.addClass("hidden");
        // Dismiss modal
        $("#notifymodal").modal("hide");
        // Send information
        $.addNotifyBackInStock(sku, "");
        $terms.attr("checked", false);
        return true;
    }
});
// Multi add child products
$(".multi-add").on("click", function() {
    $.addMultipleCartItems("multiitemadd");
    return false;
});
$(document).ready(function() {
    $.compatListInit({});
    $(".compatibility_list").change(function() {
        $.buildCompatList($(this));
    });
});
// Update Order Summary on Add to Cart
nAddItemCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
nAddMultiItemsCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
nRemoveItemCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
// Update Order Summary
function $8b5bbe8eeb487c73$var$updateOrderSummary() {
    $.load_ajax_template("_order_summary", {});
}


const $33151c6d3bf6cc96$export$c99e242bffb864af = window.innerWidth;
const $33151c6d3bf6cc96$export$83c62512efb68338 = window.innerHeight;
function $33151c6d3bf6cc96$export$f531f92e2a15358f() {
    window.resetEvent = new Event("reset");
    window.popupsClosedEvent = new Event("popupsClosed");
    window.popupOpenEvent = new Event("popupOpen");
    window.qtyChangeEvent = new Event("qtyChange");
    window.resetQtyEvent = new Event("resetQty");
    window.itemsLoadedEvent = new Event("itemsLoaded");
}
function $33151c6d3bf6cc96$export$4a59b34ae617836() {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${$33151c6d3bf6cc96$export$83c62512efb68338}px`);
}
function $33151c6d3bf6cc96$export$515dbd4fb6a22d5a() {
    window.addEventListener("resize", $33151c6d3bf6cc96$export$4a59b34ae617836);
}
function $33151c6d3bf6cc96$export$5cf963806c4f5dc7(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= $33151c6d3bf6cc96$export$83c62512efb68338;
}
function $33151c6d3bf6cc96$export$62976f5619263b39(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= $33151c6d3bf6cc96$export$83c62512efb68338;
}
function $33151c6d3bf6cc96$export$53a0910f038337bd(el, offset) {
    const scroll = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scroll({
        top: scroll,
        behavior: "smooth"
    });
}
function $33151c6d3bf6cc96$export$924fdf84dc385218(price) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    }).format(price);
}
var $33151c6d3bf6cc96$export$7b1795bf935bef37;
(function(ShowHide) {
    ShowHide["SHOW_MORE"] = "SHOW MORE";
    ShowHide["SHOW_LESS"] = "SHOW LESS";
})($33151c6d3bf6cc96$export$7b1795bf935bef37 || ($33151c6d3bf6cc96$export$7b1795bf935bef37 = {}));


function $faa24f22a5163ec6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $faa24f22a5163ec6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $faa24f22a5163ec6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $faa24f22a5163ec6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $faa24f22a5163ec6$var$CREATED = 1;
var $faa24f22a5163ec6$var$MOUNTED = 2;
var $faa24f22a5163ec6$var$IDLE = 3;
var $faa24f22a5163ec6$var$MOVING = 4;
var $faa24f22a5163ec6$var$SCROLLING = 5;
var $faa24f22a5163ec6$var$DRAGGING = 6;
var $faa24f22a5163ec6$var$DESTROYED = 7;
var $faa24f22a5163ec6$var$STATES = {
    CREATED: $faa24f22a5163ec6$var$CREATED,
    MOUNTED: $faa24f22a5163ec6$var$MOUNTED,
    IDLE: $faa24f22a5163ec6$var$IDLE,
    MOVING: $faa24f22a5163ec6$var$MOVING,
    SCROLLING: $faa24f22a5163ec6$var$SCROLLING,
    DRAGGING: $faa24f22a5163ec6$var$DRAGGING,
    DESTROYED: $faa24f22a5163ec6$var$DESTROYED
};
function $faa24f22a5163ec6$var$empty(array) {
    array.length = 0;
}
function $faa24f22a5163ec6$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $faa24f22a5163ec6$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
}
var $faa24f22a5163ec6$var$nextTick = setTimeout;
var $faa24f22a5163ec6$var$noop = function noop() {};
function $faa24f22a5163ec6$var$raf(func) {
    return requestAnimationFrame(func);
}
function $faa24f22a5163ec6$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $faa24f22a5163ec6$var$isObject(subject) {
    return !$faa24f22a5163ec6$var$isNull(subject) && $faa24f22a5163ec6$var$typeOf("object", subject);
}
var $faa24f22a5163ec6$var$isArray = Array.isArray;
var $faa24f22a5163ec6$var$isFunction = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "function");
var $faa24f22a5163ec6$var$isString = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "string");
var $faa24f22a5163ec6$var$isUndefined = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$typeOf, "undefined");
function $faa24f22a5163ec6$var$isNull(subject) {
    return subject === null;
}
function $faa24f22a5163ec6$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $faa24f22a5163ec6$var$toArray(value) {
    return $faa24f22a5163ec6$var$isArray(value) ? value : [
        value
    ];
}
function $faa24f22a5163ec6$var$forEach(values, iteratee) {
    $faa24f22a5163ec6$var$toArray(values).forEach(iteratee);
}
function $faa24f22a5163ec6$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $faa24f22a5163ec6$var$push(array, items) {
    array.push.apply(array, $faa24f22a5163ec6$var$toArray(items));
    return array;
}
function $faa24f22a5163ec6$var$toggleClass(elm, classes, add) {
    if (elm) $faa24f22a5163ec6$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $faa24f22a5163ec6$var$addClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, $faa24f22a5163ec6$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $faa24f22a5163ec6$var$append(parent, children) {
    $faa24f22a5163ec6$var$forEach(children, parent.appendChild.bind(parent));
}
function $faa24f22a5163ec6$var$before(nodes, ref) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $faa24f22a5163ec6$var$matches(elm, selector) {
    return $faa24f22a5163ec6$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $faa24f22a5163ec6$var$children(parent, selector) {
    var children2 = parent ? $faa24f22a5163ec6$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $faa24f22a5163ec6$var$matches(child, selector);
    }) : children2;
}
function $faa24f22a5163ec6$var$child(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $faa24f22a5163ec6$var$ownKeys = Object.keys;
function $faa24f22a5163ec6$var$forOwn(object, iteratee, right) {
    if (object) (right ? $faa24f22a5163ec6$var$ownKeys(object).reverse() : $faa24f22a5163ec6$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $faa24f22a5163ec6$var$assign(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$merge(object) {
    $faa24f22a5163ec6$var$slice(arguments, 1).forEach(function(source) {
        $faa24f22a5163ec6$var$forOwn(source, function(value, key) {
            if ($faa24f22a5163ec6$var$isArray(value)) object[key] = value.slice();
            else if ($faa24f22a5163ec6$var$isObject(value)) object[key] = $faa24f22a5163ec6$var$merge({}, $faa24f22a5163ec6$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $faa24f22a5163ec6$var$omit(object, keys) {
    $faa24f22a5163ec6$var$forEach(keys || $faa24f22a5163ec6$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $faa24f22a5163ec6$var$removeAttribute(elms, attrs) {
    $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $faa24f22a5163ec6$var$setAttribute(elms, attrs, value) {
    if ($faa24f22a5163ec6$var$isObject(attrs)) $faa24f22a5163ec6$var$forOwn(attrs, function(value2, name) {
        $faa24f22a5163ec6$var$setAttribute(elms, name, value2);
    });
    else $faa24f22a5163ec6$var$forEach(elms, function(elm) {
        $faa24f22a5163ec6$var$isNull(value) || value === "" ? $faa24f22a5163ec6$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $faa24f22a5163ec6$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $faa24f22a5163ec6$var$isString(attrs) ? $faa24f22a5163ec6$var$addClass(elm, attrs) : $faa24f22a5163ec6$var$setAttribute(elm, attrs);
    parent && $faa24f22a5163ec6$var$append(parent, elm);
    return elm;
}
function $faa24f22a5163ec6$var$style(elm, prop, value) {
    if ($faa24f22a5163ec6$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$faa24f22a5163ec6$var$isNull(value)) elm.style[prop] = "" + value;
}
function $faa24f22a5163ec6$var$display(elm, display2) {
    $faa24f22a5163ec6$var$style(elm, "display", display2);
}
function $faa24f22a5163ec6$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $faa24f22a5163ec6$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $faa24f22a5163ec6$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $faa24f22a5163ec6$var$rect(target) {
    return target.getBoundingClientRect();
}
function $faa24f22a5163ec6$var$remove(nodes) {
    $faa24f22a5163ec6$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $faa24f22a5163ec6$var$parseHtml(html) {
    return $faa24f22a5163ec6$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $faa24f22a5163ec6$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $faa24f22a5163ec6$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $faa24f22a5163ec6$var$queryAll(parent, selector) {
    return selector ? $faa24f22a5163ec6$var$slice(parent.querySelectorAll(selector)) : [];
}
function $faa24f22a5163ec6$var$removeClass(elm, classes) {
    $faa24f22a5163ec6$var$toggleClass(elm, classes, false);
}
function $faa24f22a5163ec6$var$timeOf(e) {
    return e.timeStamp;
}
function $faa24f22a5163ec6$var$unit(value) {
    return $faa24f22a5163ec6$var$isString(value) ? value : value ? value + "px" : "";
}
var $faa24f22a5163ec6$var$PROJECT_CODE = "splide";
var $faa24f22a5163ec6$var$DATA_ATTRIBUTE = "data-" + $faa24f22a5163ec6$var$PROJECT_CODE;
function $faa24f22a5163ec6$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $faa24f22a5163ec6$var$PROJECT_CODE + "] " + (message || ""));
}
var $faa24f22a5163ec6$var$min = Math.min, $faa24f22a5163ec6$var$max = Math.max, $faa24f22a5163ec6$var$floor = Math.floor, $faa24f22a5163ec6$var$ceil = Math.ceil, $faa24f22a5163ec6$var$abs = Math.abs;
function $faa24f22a5163ec6$var$approximatelyEqual(x, y, epsilon) {
    return $faa24f22a5163ec6$var$abs(x - y) < epsilon;
}
function $faa24f22a5163ec6$var$between(number, x, y, exclusive) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $faa24f22a5163ec6$var$clamp(number, x, y) {
    var minimum = $faa24f22a5163ec6$var$min(x, y);
    var maximum = $faa24f22a5163ec6$var$max(x, y);
    return $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$max(minimum, number), maximum);
}
function $faa24f22a5163ec6$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $faa24f22a5163ec6$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $faa24f22a5163ec6$var$format(string, replacements) {
    $faa24f22a5163ec6$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $faa24f22a5163ec6$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $faa24f22a5163ec6$var$ids = {};
function $faa24f22a5163ec6$var$uniqueId(prefix) {
    return "" + prefix + $faa24f22a5163ec6$var$pad($faa24f22a5163ec6$var$ids[prefix] = ($faa24f22a5163ec6$var$ids[prefix] || 0) + 1);
}
function $faa24f22a5163ec6$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $faa24f22a5163ec6$var$forEach(targets, function(target) {
            target && $faa24f22a5163ec6$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $faa24f22a5163ec6$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$export$d300dc1a2634364b = "mounted";
var $faa24f22a5163ec6$export$d8dac49b4532735a = "ready";
var $faa24f22a5163ec6$export$2aa493d7c3275167 = "move";
var $faa24f22a5163ec6$export$fe5802204b967f0d = "moved";
var $faa24f22a5163ec6$export$5adb665701eda1ce = "click";
var $faa24f22a5163ec6$export$92e3eae133acac4c = "active";
var $faa24f22a5163ec6$export$6bcbb81035c12cea = "inactive";
var $faa24f22a5163ec6$export$6a5b3445e4066a53 = "visible";
var $faa24f22a5163ec6$export$8c5c7a21d54563e9 = "hidden";
var $faa24f22a5163ec6$export$7f4701ac5e05e39f = "refresh";
var $faa24f22a5163ec6$export$db40ab7c0855fa5c = "updated";
var $faa24f22a5163ec6$export$7e019dae5103a285 = "resize";
var $faa24f22a5163ec6$export$d637eba1e9e28482 = "resized";
var $faa24f22a5163ec6$export$e84bf5065c9087ac = "drag";
var $faa24f22a5163ec6$export$8e9f636d2c722196 = "dragging";
var $faa24f22a5163ec6$export$90ea576bd3fdeb60 = "dragged";
var $faa24f22a5163ec6$export$49801896908b5e33 = "scroll";
var $faa24f22a5163ec6$export$ff8164bff3202b9 = "scrolled";
var $faa24f22a5163ec6$export$6cbac5b662a31e1b = "overflow";
var $faa24f22a5163ec6$export$88c4cf7419e470cd = "destroy";
var $faa24f22a5163ec6$export$8647f6b043e04e9d = "arrows:mounted";
var $faa24f22a5163ec6$export$d467f9343b961f75 = "arrows:updated";
var $faa24f22a5163ec6$export$bf89a4e4349c9778 = "pagination:mounted";
var $faa24f22a5163ec6$export$eb2019082ed6de0b = "pagination:updated";
var $faa24f22a5163ec6$export$84015c33508f94ec = "navigation:mounted";
var $faa24f22a5163ec6$export$23663268a31b79e2 = "autoplay:play";
var $faa24f22a5163ec6$export$185723258309b608 = "autoplay:playing";
var $faa24f22a5163ec6$export$16a1e4f3d0368265 = "autoplay:pause";
var $faa24f22a5163ec6$export$9f64346e17f0ec8e = "lazyload:loaded";
var $faa24f22a5163ec6$export$6d5af59619d10e6a = "sk";
var $faa24f22a5163ec6$export$f0af896383d5adff = "sh";
var $faa24f22a5163ec6$export$28dea85f216954dc = "ei";
function $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $faa24f22a5163ec6$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $faa24f22a5163ec6$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $faa24f22a5163ec6$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($faa24f22a5163ec6$export$88c4cf7419e470cd, binder.destroy);
    return $faa24f22a5163ec6$var$assign(binder, {
        bus: bus,
        on: on,
        off: $faa24f22a5163ec6$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $faa24f22a5163ec6$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $faa24f22a5163ec6$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $faa24f22a5163ec6$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $faa24f22a5163ec6$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $faa24f22a5163ec6$export$efff0f5979573c99(func, duration) {
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $faa24f22a5163ec6$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $faa24f22a5163ec6$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $faa24f22a5163ec6$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($faa24f22a5163ec6$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $faa24f22a5163ec6$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $faa24f22a5163ec6$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($faa24f22a5163ec6$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $faa24f22a5163ec6$var$merge(options, reducedMotion) : $faa24f22a5163ec6$var$omit(options, $faa24f22a5163ec6$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $faa24f22a5163ec6$var$merge(options, opts);
        base && $faa24f22a5163ec6$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($faa24f22a5163ec6$var$CREATED)) Splide2.emit($faa24f22a5163ec6$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $faa24f22a5163ec6$var$ARROW = "Arrow";
var $faa24f22a5163ec6$var$ARROW_LEFT = $faa24f22a5163ec6$var$ARROW + "Left";
var $faa24f22a5163ec6$var$ARROW_RIGHT = $faa24f22a5163ec6$var$ARROW + "Right";
var $faa24f22a5163ec6$var$ARROW_UP = $faa24f22a5163ec6$var$ARROW + "Up";
var $faa24f22a5163ec6$var$ARROW_DOWN = $faa24f22a5163ec6$var$ARROW + "Down";
var $faa24f22a5163ec6$export$373e92e0788ff06e = "ltr";
var $faa24f22a5163ec6$export$850f7749a2909601 = "rtl";
var $faa24f22a5163ec6$export$97170d9824b89709 = "ttb";
var $faa24f22a5163ec6$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $faa24f22a5163ec6$var$ARROW_UP,
        $faa24f22a5163ec6$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $faa24f22a5163ec6$var$ARROW_DOWN,
        $faa24f22a5163ec6$var$ARROW_LEFT
    ]
};
function $faa24f22a5163ec6$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $faa24f22a5163ec6$export$850f7749a2909601 && !axisOnly ? 1 : direction === $faa24f22a5163ec6$export$97170d9824b89709 ? 0 : -1;
        return $faa24f22a5163ec6$var$ORIENTATION_MAP[prop] && $faa24f22a5163ec6$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $faa24f22a5163ec6$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $faa24f22a5163ec6$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $faa24f22a5163ec6$var$ROLE = "role";
var $faa24f22a5163ec6$var$TAB_INDEX = "tabindex";
var $faa24f22a5163ec6$var$DISABLED = "disabled";
var $faa24f22a5163ec6$var$ARIA_PREFIX = "aria-";
var $faa24f22a5163ec6$var$ARIA_CONTROLS = $faa24f22a5163ec6$var$ARIA_PREFIX + "controls";
var $faa24f22a5163ec6$var$ARIA_CURRENT = $faa24f22a5163ec6$var$ARIA_PREFIX + "current";
var $faa24f22a5163ec6$var$ARIA_SELECTED = $faa24f22a5163ec6$var$ARIA_PREFIX + "selected";
var $faa24f22a5163ec6$var$ARIA_LABEL = $faa24f22a5163ec6$var$ARIA_PREFIX + "label";
var $faa24f22a5163ec6$var$ARIA_LABELLEDBY = $faa24f22a5163ec6$var$ARIA_PREFIX + "labelledby";
var $faa24f22a5163ec6$var$ARIA_HIDDEN = $faa24f22a5163ec6$var$ARIA_PREFIX + "hidden";
var $faa24f22a5163ec6$var$ARIA_ORIENTATION = $faa24f22a5163ec6$var$ARIA_PREFIX + "orientation";
var $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION = $faa24f22a5163ec6$var$ARIA_PREFIX + "roledescription";
var $faa24f22a5163ec6$var$ARIA_LIVE = $faa24f22a5163ec6$var$ARIA_PREFIX + "live";
var $faa24f22a5163ec6$var$ARIA_BUSY = $faa24f22a5163ec6$var$ARIA_PREFIX + "busy";
var $faa24f22a5163ec6$var$ARIA_ATOMIC = $faa24f22a5163ec6$var$ARIA_PREFIX + "atomic";
var $faa24f22a5163ec6$var$ALL_ATTRIBUTES = [
    $faa24f22a5163ec6$var$ROLE,
    $faa24f22a5163ec6$var$TAB_INDEX,
    $faa24f22a5163ec6$var$DISABLED,
    $faa24f22a5163ec6$var$ARIA_CONTROLS,
    $faa24f22a5163ec6$var$ARIA_CURRENT,
    $faa24f22a5163ec6$var$ARIA_LABEL,
    $faa24f22a5163ec6$var$ARIA_LABELLEDBY,
    $faa24f22a5163ec6$var$ARIA_HIDDEN,
    $faa24f22a5163ec6$var$ARIA_ORIENTATION,
    $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
];
var $faa24f22a5163ec6$var$CLASS_PREFIX = $faa24f22a5163ec6$var$PROJECT_CODE + "__";
var $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX = "is-";
var $faa24f22a5163ec6$export$93b21159ad85c843 = $faa24f22a5163ec6$var$PROJECT_CODE;
var $faa24f22a5163ec6$export$7738b09ac0a98952 = $faa24f22a5163ec6$var$CLASS_PREFIX + "track";
var $faa24f22a5163ec6$export$19cc2a5451235cae = $faa24f22a5163ec6$var$CLASS_PREFIX + "list";
var $faa24f22a5163ec6$export$8d922915837a38d3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "slide";
var $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 = $faa24f22a5163ec6$export$8d922915837a38d3 + "--clone";
var $faa24f22a5163ec6$export$e9ba7e444ba60a12 = $faa24f22a5163ec6$export$8d922915837a38d3 + "__container";
var $faa24f22a5163ec6$export$a26cbd955fecf11e = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrows";
var $faa24f22a5163ec6$export$516e7d18e13a2dca = $faa24f22a5163ec6$var$CLASS_PREFIX + "arrow";
var $faa24f22a5163ec6$export$58ea3db24c33b76 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--prev";
var $faa24f22a5163ec6$export$4885afd7098a65c2 = $faa24f22a5163ec6$export$516e7d18e13a2dca + "--next";
var $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 = $faa24f22a5163ec6$var$CLASS_PREFIX + "pagination";
var $faa24f22a5163ec6$export$52f2cca6a5eee805 = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "__page";
var $faa24f22a5163ec6$export$4c82dc32b1c4ace5 = $faa24f22a5163ec6$var$CLASS_PREFIX + "progress";
var $faa24f22a5163ec6$export$2c9b091c749f4409 = $faa24f22a5163ec6$export$4c82dc32b1c4ace5 + "__bar";
var $faa24f22a5163ec6$export$a29701deef84b825 = $faa24f22a5163ec6$var$CLASS_PREFIX + "toggle";
var $faa24f22a5163ec6$export$d9d247d51b430dbb = $faa24f22a5163ec6$export$a29701deef84b825 + "__play";
var $faa24f22a5163ec6$export$3529f201a419925b = $faa24f22a5163ec6$export$a29701deef84b825 + "__pause";
var $faa24f22a5163ec6$export$3e5381ee3fab8374 = $faa24f22a5163ec6$var$CLASS_PREFIX + "spinner";
var $faa24f22a5163ec6$export$bb78d7c200da8960 = $faa24f22a5163ec6$var$CLASS_PREFIX + "sr";
var $faa24f22a5163ec6$export$7761661e2d5b9388 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "initialized";
var $faa24f22a5163ec6$export$72d36ecf3758cb4b = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "active";
var $faa24f22a5163ec6$export$e423ac4972f5e196 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "prev";
var $faa24f22a5163ec6$export$457a2d20827a2779 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "next";
var $faa24f22a5163ec6$export$53ca4621bbab9a = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "visible";
var $faa24f22a5163ec6$export$d22ec4ccb7996ba2 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "loading";
var $faa24f22a5163ec6$export$b6f202a162a09100 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "focus-in";
var $faa24f22a5163ec6$export$cd908cd1dd625e29 = $faa24f22a5163ec6$var$STATUS_CLASS_PREFIX + "overflow";
var $faa24f22a5163ec6$export$49f9eaea10ebf193 = [
    $faa24f22a5163ec6$export$72d36ecf3758cb4b,
    $faa24f22a5163ec6$export$53ca4621bbab9a,
    $faa24f22a5163ec6$export$e423ac4972f5e196,
    $faa24f22a5163ec6$export$457a2d20827a2779,
    $faa24f22a5163ec6$export$d22ec4ccb7996ba2,
    $faa24f22a5163ec6$export$b6f202a162a09100,
    $faa24f22a5163ec6$export$cd908cd1dd625e29
];
var $faa24f22a5163ec6$export$ba41d43e4a419565 = {
    slide: $faa24f22a5163ec6$export$8d922915837a38d3,
    clone: $faa24f22a5163ec6$export$2c1ba4a4f1aa4947,
    arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
    arrow: $faa24f22a5163ec6$export$516e7d18e13a2dca,
    prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
    next: $faa24f22a5163ec6$export$4885afd7098a65c2,
    pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
    page: $faa24f22a5163ec6$export$52f2cca6a5eee805,
    spinner: $faa24f22a5163ec6$export$3e5381ee3fab8374
};
function $faa24f22a5163ec6$var$closest(from, selector) {
    if ($faa24f22a5163ec6$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($faa24f22a5163ec6$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $faa24f22a5163ec6$var$FRICTION = 5;
var $faa24f22a5163ec6$var$LOG_INTERVAL = 200;
var $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $faa24f22a5163ec6$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $faa24f22a5163ec6$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, setup);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, update);
        bind(document, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $faa24f22a5163ec6$var$ALL_ATTRIBUTES.concat("style");
        $faa24f22a5163ec6$var$empty(slides);
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        $faa24f22a5163ec6$var$removeAttribute([
            track,
            list
        ], attrs);
        $faa24f22a5163ec6$var$removeAttribute(root, completely ? attrs : [
            "style",
            $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $faa24f22a5163ec6$var$removeClass(root, rootClasses);
        $faa24f22a5163ec6$var$removeClass(track, trackClasses);
        rootClasses = getClasses($faa24f22a5163ec6$export$93b21159ad85c843);
        trackClasses = getClasses($faa24f22a5163ec6$export$7738b09ac0a98952);
        $faa24f22a5163ec6$var$addClass(root, rootClasses);
        $faa24f22a5163ec6$var$addClass(track, trackClasses);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL, options.label);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $faa24f22a5163ec6$export$7738b09ac0a98952);
        list = $faa24f22a5163ec6$var$child(track, "." + $faa24f22a5163ec6$export$19cc2a5451235cae);
        $faa24f22a5163ec6$var$assert(track && list, "A track/list element is missing.");
        $faa24f22a5163ec6$var$push(slides, $faa24f22a5163ec6$var$children(list, "." + $faa24f22a5163ec6$export$8d922915837a38d3 + ":not(." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947 + ")"));
        $faa24f22a5163ec6$var$forOwn({
            arrows: $faa24f22a5163ec6$export$a26cbd955fecf11e,
            pagination: $faa24f22a5163ec6$export$cbf8e5a0ab95eda3,
            prev: $faa24f22a5163ec6$export$58ea3db24c33b76,
            next: $faa24f22a5163ec6$export$4885afd7098a65c2,
            bar: $faa24f22a5163ec6$export$2c9b091c749f4409,
            toggle: $faa24f22a5163ec6$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $faa24f22a5163ec6$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $faa24f22a5163ec6$var$uniqueId($faa24f22a5163ec6$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ROLE) && root.tagName !== "SECTION" && role) $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ROLE, role);
        $faa24f22a5163ec6$var$setAttribute(root, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $faa24f22a5163ec6$var$query(root, selector);
        return elm && $faa24f22a5163ec6$var$closest(elm, "." + $faa24f22a5163ec6$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $faa24f22a5163ec6$export$93b21159ad85c843 && $faa24f22a5163ec6$export$72d36ecf3758cb4b
        ];
    }
    return $faa24f22a5163ec6$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $faa24f22a5163ec6$export$e5a58a5ee5b54c22 = "slide";
var $faa24f22a5163ec6$export$f42383286ed1223d = "loop";
var $faa24f22a5163ec6$export$742b62a5690c060 = "fade";
function $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $faa24f22a5163ec6$var$getAttribute(slide, "style");
    var label = $faa24f22a5163ec6$var$getAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $faa24f22a5163ec6$var$child(slide, "." + $faa24f22a5163ec6$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $faa24f22a5163ec6$var$pad(index + 1);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, pagination ? "tabpanel" : "group");
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || $faa24f22a5163ec6$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$6d5af59619d10e6a, self));
        on([
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$f0af896383d5adff,
            $faa24f22a5163ec6$export$ff8164bff3202b9
        ], update);
        on($faa24f22a5163ec6$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(slide, $faa24f22a5163ec6$export$49f9eaea10ebf193);
        $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
        $faa24f22a5163ec6$var$setAttribute(slide, "style", styles);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls);
        $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $faa24f22a5163ec6$var$removeAttribute(slide, $faa24f22a5163ec6$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$e423ac4972f5e196, index === curr - 1);
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$72d36ecf3758cb4b, active);
            $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $faa24f22a5163ec6$export$92e3eae133acac4c : $faa24f22a5163ec6$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ])) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$ARIA_HIDDEN, hidden || "");
        $faa24f22a5163ec6$var$setAttribute($faa24f22a5163ec6$var$queryAll(slide, options.focusableNodes || ""), $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $faa24f22a5163ec6$var$setAttribute(slide, $faa24f22a5163ec6$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $faa24f22a5163ec6$var$hasClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a)) {
            $faa24f22a5163ec6$var$toggleClass(slide, $faa24f22a5163ec6$export$53ca4621bbab9a, visible);
            emit(visible ? $faa24f22a5163ec6$export$6a5b3445e4066a53 : $faa24f22a5163ec6$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $faa24f22a5163ec6$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $faa24f22a5163ec6$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) return isActive();
        var trackRect = $faa24f22a5163ec6$var$rect(Components.Elements.track);
        var slideRect = $faa24f22a5163ec6$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $faa24f22a5163ec6$var$floor(trackRect[left]) <= $faa24f22a5163ec6$var$ceil(slideRect[left]) && $faa24f22a5163ec6$var$floor(slideRect[right]) <= $faa24f22a5163ec6$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $faa24f22a5163ec6$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d))) diff = $faa24f22a5163ec6$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $faa24f22a5163ec6$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, destroy);
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $faa24f22a5163ec6$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $faa24f22a5163ec6$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $faa24f22a5163ec6$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $faa24f22a5163ec6$var$forEach(items, function(slide) {
            if ($faa24f22a5163ec6$var$isString(slide)) slide = $faa24f22a5163ec6$var$parseHtml(slide);
            if ($faa24f22a5163ec6$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $faa24f22a5163ec6$var$before(slide, ref) : $faa24f22a5163ec6$var$append(list, slide);
                $faa24f22a5163ec6$var$addClass(slide, options.classes.slide);
                observeImages(slide, $faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285));
            }
        });
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $faa24f22a5163ec6$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($faa24f22a5163ec6$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $faa24f22a5163ec6$var$isString(matcher) ? $faa24f22a5163ec6$var$matches(Slide2.slide, matcher) : $faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $faa24f22a5163ec6$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $faa24f22a5163ec6$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $faa24f22a5163ec6$export$efff0f5979573c99($faa24f22a5163ec6$var$apply(emit, $faa24f22a5163ec6$export$7e019dae5103a285)));
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
        on($faa24f22a5163ec6$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
        $faa24f22a5163ec6$var$style(root, "maxWidth", $faa24f22a5163ec6$var$unit(options.width));
        $faa24f22a5163ec6$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $faa24f22a5163ec6$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $faa24f22a5163ec6$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $faa24f22a5163ec6$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($faa24f22a5163ec6$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $faa24f22a5163ec6$var$toggleClass(root, $faa24f22a5163ec6$export$cd908cd1dd625e29, overflow);
                emit($faa24f22a5163ec6$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $faa24f22a5163ec6$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $faa24f22a5163ec6$var$unit(options.height || $faa24f22a5163ec6$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $faa24f22a5163ec6$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $faa24f22a5163ec6$var$rect(Slide.slide)[resolve("right")];
            var left = $faa24f22a5163ec6$var$rect(list)[resolve("left")];
            return $faa24f22a5163ec6$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($faa24f22a5163ec6$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($faa24f22a5163ec6$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($faa24f22a5163ec6$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $faa24f22a5163ec6$var$MULTIPLIER = 2;
function $faa24f22a5163ec6$var$Clones(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($faa24f22a5163ec6$export$7f4701ac5e05e39f, remount);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $faa24f22a5163ec6$var$remove(clones);
        $faa24f22a5163ec6$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
            $faa24f22a5163ec6$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $faa24f22a5163ec6$var$before(clone, slides[0].slide) : $faa24f22a5163ec6$var$append(Elements.list, clone);
                $faa24f22a5163ec6$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $faa24f22a5163ec6$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $faa24f22a5163ec6$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) clones2 = 0;
        else if ($faa24f22a5163ec6$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $faa24f22a5163ec6$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $faa24f22a5163ec6$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$d637eba1e9e28482,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($faa24f22a5163ec6$var$MOVING);
        emit($faa24f22a5163ec6$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $faa24f22a5163ec6$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($faa24f22a5163ec6$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($faa24f22a5163ec6$var$ceil($faa24f22a5163ec6$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $faa24f22a5163ec6$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $faa24f22a5163ec6$var$rect(list)[left] - $faa24f22a5163ec6$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22)) position = $faa24f22a5163ec6$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $faa24f22a5163ec6$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $faa24f22a5163ec6$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $faa24f22a5163ec6$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d);
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var getNext = $faa24f22a5163ec6$var$apply(getAdjacent, false);
    var getPrev = $faa24f22a5163ec6$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], init);
        on($faa24f22a5163ec6$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $faa24f22a5163ec6$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($faa24f22a5163ec6$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $faa24f22a5163ec6$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($faa24f22a5163ec6$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $faa24f22a5163ec6$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$faa24f22a5163ec6$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($faa24f22a5163ec6$var$between(0, dest, from, true) || $faa24f22a5163ec6$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $faa24f22a5163ec6$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $faa24f22a5163ec6$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $faa24f22a5163ec6$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $faa24f22a5163ec6$var$min(index, endIndex) : $faa24f22a5163ec6$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $faa24f22a5163ec6$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$faa24f22a5163ec6$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $faa24f22a5163ec6$var$MOVING,
            $faa24f22a5163ec6$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $faa24f22a5163ec6$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $faa24f22a5163ec6$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $faa24f22a5163ec6$var$SIZE = 40;
function $faa24f22a5163ec6$var$Arrows(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $faa24f22a5163ec6$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $faa24f22a5163ec6$var$display(wrapper, enabled ? "" : "none");
            $faa24f22a5163ec6$var$addClass(wrapper, wrapperClasses = $faa24f22a5163ec6$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $faa24f22a5163ec6$var$setAttribute([
                    prev,
                    next
                ], $faa24f22a5163ec6$var$ARIA_CONTROLS, track.id);
                emit($faa24f22a5163ec6$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $faa24f22a5163ec6$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $faa24f22a5163ec6$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $faa24f22a5163ec6$var$removeAttribute([
            prev,
            next
        ], $faa24f22a5163ec6$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$fe5802204b967f0d,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$ff8164bff3202b9,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], update);
        bind(next, "click", $faa24f22a5163ec6$var$apply(go, ">"));
        bind(prev, "click", $faa24f22a5163ec6$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $faa24f22a5163ec6$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $faa24f22a5163ec6$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $faa24f22a5163ec6$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $faa24f22a5163ec6$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + '" width="' + $faa24f22a5163ec6$var$SIZE + '" height="' + $faa24f22a5163ec6$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $faa24f22a5163ec6$var$PATH) + '" />';
        return $faa24f22a5163ec6$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $faa24f22a5163ec6$var$setAttribute(prev, $faa24f22a5163ec6$var$ARIA_LABEL, prevLabel);
            $faa24f22a5163ec6$var$setAttribute(next, $faa24f22a5163ec6$var$ARIA_LABEL, nextLabel);
            emit($faa24f22a5163ec6$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-interval";
function $faa24f22a5163ec6$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $faa24f22a5163ec6$export$2aa493d7c3275167,
            $faa24f22a5163ec6$export$49801896908b5e33,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($faa24f22a5163ec6$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($faa24f22a5163ec6$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $faa24f22a5163ec6$var$toggleClass(toggle, $faa24f22a5163ec6$export$72d36ecf3758cb4b, !stopped);
            $faa24f22a5163ec6$var$setAttribute(toggle, $faa24f22a5163ec6$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $faa24f22a5163ec6$var$style(bar, "width", rate * 100 + "%");
        emit($faa24f22a5163ec6$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$faa24f22a5163ec6$var$getAttribute(Slide.slide, $faa24f22a5163ec6$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $faa24f22a5163ec6$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($faa24f22a5163ec6$export$9f64346e17f0ec8e, $faa24f22a5163ec6$var$apply(toggle, true));
            on([
                $faa24f22a5163ec6$export$d300dc1a2634364b,
                $faa24f22a5163ec6$export$db40ab7c0855fa5c,
                $faa24f22a5163ec6$export$7f4701ac5e05e39f
            ], $faa24f22a5163ec6$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $faa24f22a5163ec6$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $faa24f22a5163ec6$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply(cover, false)
    };
}
var $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD = 10;
var $faa24f22a5163ec6$var$BOUNCE_DURATION = 600;
var $faa24f22a5163ec6$var$FRICTION_FACTOR = 0.6;
var $faa24f22a5163ec6$var$BASE_VELOCITY = 1.5;
var $faa24f22a5163ec6$var$MIN_DURATION = 800;
function $faa24f22a5163ec6$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($faa24f22a5163ec6$export$2aa493d7c3275167, clear);
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $faa24f22a5163ec6$var$sign(destination) * size * $faa24f22a5163ec6$var$floor($faa24f22a5163ec6$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $faa24f22a5163ec6$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $faa24f22a5163ec6$var$max($faa24f22a5163ec6$var$abs(destination - from) / $faa24f22a5163ec6$var$BASE_VELOCITY, $faa24f22a5163ec6$var$MIN_DURATION);
        callback = onScrolled;
        interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0(duration, onEnd, $faa24f22a5163ec6$var$apply(update, from, destination, noConstrain), 1);
        set($faa24f22a5163ec6$var$SCROLLING);
        emit($faa24f22a5163ec6$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($faa24f22a5163ec6$var$IDLE);
        callback && callback();
        emit($faa24f22a5163ec6$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $faa24f22a5163ec6$var$FRICTION_FACTOR;
            if ($faa24f22a5163ec6$var$abs(diff) < $faa24f22a5163ec6$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $faa24f22a5163ec6$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $faa24f22a5163ec6$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, $faa24f22a5163ec6$var$noop, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $faa24f22a5163ec6$var$POINTER_DOWN_EVENTS, onPointerDown, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $faa24f22a5163ec6$var$prevent);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $faa24f22a5163ec6$var$MOVING,
                        $faa24f22a5163ec6$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $faa24f22a5163ec6$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$DRAGGING);
            emit($faa24f22a5163ec6$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $faa24f22a5163ec6$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($faa24f22a5163ec6$export$8e9f636d2c722196);
                $faa24f22a5163ec6$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $faa24f22a5163ec6$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($faa24f22a5163ec6$var$DRAGGING)) {
            state.set($faa24f22a5163ec6$var$IDLE);
            emit($faa24f22a5163ec6$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $faa24f22a5163ec6$var$prevent(e);
        }
        unbind(target, $faa24f22a5163ec6$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $faa24f22a5163ec6$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $faa24f22a5163ec6$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($faa24f22a5163ec6$export$742b62a5690c060)) Controller.go(orient($faa24f22a5163ec6$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $faa24f22a5163ec6$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $faa24f22a5163ec6$var$abs(diffCoord(e)) > $faa24f22a5163ec6$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($faa24f22a5163ec6$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $faa24f22a5163ec6$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $faa24f22a5163ec6$var$sign(velocity) * $faa24f22a5163ec6$var$min($faa24f22a5163ec6$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $faa24f22a5163ec6$var$timeOf(e) - $faa24f22a5163ec6$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) ? $faa24f22a5163ec6$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$faa24f22a5163ec6$var$matches(target2, "." + $faa24f22a5163ec6$export$52f2cca6a5eee805 + ", ." + $faa24f22a5163ec6$export$516e7d18e13a2dca) && (!noDrag || !$faa24f22a5163ec6$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $faa24f22a5163ec6$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $faa24f22a5163ec6$var$ARROW_RIGHT,
    Left: $faa24f22a5163ec6$var$ARROW_LEFT,
    Up: $faa24f22a5163ec6$var$ARROW_UP,
    Down: $faa24f22a5163ec6$var$ARROW_DOWN
};
function $faa24f22a5163ec6$var$normalizeKey(key) {
    key = $faa24f22a5163ec6$var$isString(key) ? key : key.key;
    return $faa24f22a5163ec6$var$NORMALIZATION_MAP[key] || key;
}
var $faa24f22a5163ec6$var$KEYBOARD_EVENT = "keydown";
function $faa24f22a5163ec6$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, destroy);
        on($faa24f22a5163ec6$export$db40ab7c0855fa5c, init);
        on($faa24f22a5163ec6$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $faa24f22a5163ec6$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $faa24f22a5163ec6$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $faa24f22a5163ec6$var$normalizeKey(e);
            if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$DATA_ATTRIBUTE + "-lazy";
var $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE = $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $faa24f22a5163ec6$var$IMAGE_SELECTOR = "[" + $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE + "], [" + $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE + "]";
function $faa24f22a5163ec6$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $faa24f22a5163ec6$export$fe5802204b967f0d,
        $faa24f22a5163ec6$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($faa24f22a5163ec6$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $faa24f22a5163ec6$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $faa24f22a5163ec6$var$queryAll(Slide.slide, $faa24f22a5163ec6$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
                var srcset = $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $faa24f22a5163ec6$var$child(parent, "." + className) || $faa24f22a5163ec6$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $faa24f22a5163ec6$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $faa24f22a5163ec6$var$addClass(data[1].slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        bind(img, "load error", $faa24f22a5163ec6$var$apply(onLoad, data));
        $faa24f22a5163ec6$var$setAttribute(img, "src", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$setAttribute(img, "srcset", $faa24f22a5163ec6$var$getAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE));
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRC_DATA_ATTRIBUTE);
        $faa24f22a5163ec6$var$removeAttribute(img, $faa24f22a5163ec6$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $faa24f22a5163ec6$var$removeClass(Slide.slide, $faa24f22a5163ec6$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $faa24f22a5163ec6$var$remove(data[2]);
            $faa24f22a5163ec6$var$display(img, "");
            emit($faa24f22a5163ec6$export$9f64346e17f0ec8e, img, Slide);
            emit($faa24f22a5163ec6$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$empty, entries),
        check: check
    };
}
function $faa24f22a5163ec6$var$Pagination(Splide2, Components2, options) {
    var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $faa24f22a5163ec6$export$db40ab7c0855fa5c,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f,
            $faa24f22a5163ec6$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $faa24f22a5163ec6$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $faa24f22a5163ec6$export$2aa493d7c3275167,
                $faa24f22a5163ec6$export$49801896908b5e33,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($faa24f22a5163ec6$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $faa24f22a5163ec6$var$remove(placeholder ? $faa24f22a5163ec6$var$slice(list.children) : list);
            $faa24f22a5163ec6$var$removeClass(list, paginationClasses);
            $faa24f22a5163ec6$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $faa24f22a5163ec6$var$ceil(length / perPage);
        list = placeholder || $faa24f22a5163ec6$var$create("ul", classes.pagination, Elements.track.parentElement);
        $faa24f22a5163ec6$var$addClass(list, paginationClasses = $faa24f22a5163ec6$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ROLE, "tablist");
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_LABEL, i18n.select);
        $faa24f22a5163ec6$var$setAttribute(list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, getDirection() === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $faa24f22a5163ec6$var$create("li", null, list);
            var button = $faa24f22a5163ec6$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $faa24f22a5163ec6$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $faa24f22a5163ec6$var$apply(onKeydown, i));
            $faa24f22a5163ec6$var$setAttribute(li, $faa24f22a5163ec6$var$ROLE, "presentation");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ROLE, "tab");
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_CONTROLS, controls.join(" "));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$ARIA_LABEL, $faa24f22a5163ec6$var$format(text, i + 1));
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $faa24f22a5163ec6$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($faa24f22a5163ec6$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($faa24f22a5163ec6$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $faa24f22a5163ec6$var$focus(item.button);
            go(">" + nextPage);
            $faa24f22a5163ec6$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $faa24f22a5163ec6$var$removeClass(button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$removeAttribute(button, $faa24f22a5163ec6$var$ARIA_SELECTED);
            $faa24f22a5163ec6$var$setAttribute(button, $faa24f22a5163ec6$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $faa24f22a5163ec6$var$addClass(_button, $faa24f22a5163ec6$export$72d36ecf3758cb4b);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$ARIA_SELECTED, true);
            $faa24f22a5163ec6$var$setAttribute(_button, $faa24f22a5163ec6$var$TAB_INDEX, "");
        }
        emit($faa24f22a5163ec6$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $faa24f22a5163ec6$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $faa24f22a5163ec6$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $faa24f22a5163ec6$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(splide);
        event.on($faa24f22a5163ec6$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($faa24f22a5163ec6$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($faa24f22a5163ec6$export$5adb665701eda1ce, onClick);
        on($faa24f22a5163ec6$export$6d5af59619d10e6a, onKeydown);
        on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($faa24f22a5163ec6$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $faa24f22a5163ec6$var$setAttribute(Components2.Elements.list, $faa24f22a5163ec6$var$ARIA_ORIENTATION, options.direction === $faa24f22a5163ec6$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($faa24f22a5163ec6$var$includes($faa24f22a5163ec6$var$TRIGGER_KEYS, $faa24f22a5163ec6$var$normalizeKey(e))) {
            onClick(Slide);
            $faa24f22a5163ec6$var$prevent(e);
        }
    }
    return {
        setup: $faa24f22a5163ec6$var$apply(Components2.Media.set, {
            slideFocus: $faa24f22a5163ec6$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $faa24f22a5163ec6$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $faa24f22a5163ec6$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $faa24f22a5163ec6$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($faa24f22a5163ec6$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $faa24f22a5163ec6$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($faa24f22a5163ec6$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $faa24f22a5163ec6$var$SR_REMOVAL_DELAY = 90;
function $faa24f22a5163ec6$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $faa24f22a5163ec6$var$create("span", $faa24f22a5163ec6$export$bb78d7c200da8960);
    var interval = $faa24f22a5163ec6$export$46ad21b25b6dccf0($faa24f22a5163ec6$var$SR_REMOVAL_DELAY, $faa24f22a5163ec6$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($faa24f22a5163ec6$export$23663268a31b79e2, $faa24f22a5163ec6$var$apply(disable, true));
            on($faa24f22a5163ec6$export$16a1e4f3d0368265, $faa24f22a5163ec6$var$apply(disable, false));
            on([
                $faa24f22a5163ec6$export$fe5802204b967f0d,
                $faa24f22a5163ec6$export$ff8164bff3202b9
            ], $faa24f22a5163ec6$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_BUSY, active);
        if (active) {
            $faa24f22a5163ec6$var$append(track, sr);
            interval.start();
        } else {
            $faa24f22a5163ec6$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $faa24f22a5163ec6$var$removeAttribute(track, [
            $faa24f22a5163ec6$var$ARIA_LIVE,
            $faa24f22a5163ec6$var$ARIA_ATOMIC,
            $faa24f22a5163ec6$var$ARIA_BUSY
        ]);
        $faa24f22a5163ec6$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $faa24f22a5163ec6$var$setAttribute(track, $faa24f22a5163ec6$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $faa24f22a5163ec6$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $faa24f22a5163ec6$var$Media,
    Direction: $faa24f22a5163ec6$var$Direction,
    Elements: $faa24f22a5163ec6$var$Elements,
    Slides: $faa24f22a5163ec6$var$Slides,
    Layout: $faa24f22a5163ec6$var$Layout,
    Clones: $faa24f22a5163ec6$var$Clones,
    Move: $faa24f22a5163ec6$var$Move,
    Controller: $faa24f22a5163ec6$var$Controller,
    Arrows: $faa24f22a5163ec6$var$Arrows,
    Autoplay: $faa24f22a5163ec6$var$Autoplay,
    Cover: $faa24f22a5163ec6$var$Cover,
    Scroll: $faa24f22a5163ec6$var$Scroll,
    Drag: $faa24f22a5163ec6$var$Drag,
    Keyboard: $faa24f22a5163ec6$var$Keyboard,
    LazyLoad: $faa24f22a5163ec6$var$LazyLoad,
    Pagination: $faa24f22a5163ec6$var$Pagination,
    Sync: $faa24f22a5163ec6$var$Sync,
    Wheel: $faa24f22a5163ec6$var$Wheel,
    Live: $faa24f22a5163ec6$var$Live
});
var $faa24f22a5163ec6$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $faa24f22a5163ec6$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $faa24f22a5163ec6$export$ba41d43e4a419565,
    i18n: $faa24f22a5163ec6$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $faa24f22a5163ec6$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).on([
            $faa24f22a5163ec6$export$d300dc1a2634364b,
            $faa24f22a5163ec6$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $faa24f22a5163ec6$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $faa24f22a5163ec6$var$noop
    };
}
function $faa24f22a5163ec6$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $faa24f22a5163ec6$var$apply($faa24f22a5163ec6$var$style, list, "transition");
    var endCallback;
    function mount() {
        $faa24f22a5163ec6$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($faa24f22a5163ec6$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($faa24f22a5163ec6$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $faa24f22a5163ec6$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $faa24f22a5163ec6$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $faa24f22a5163ec6$export$7254cc27399e90bd($faa24f22a5163ec6$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $faa24f22a5163ec6$var$isString(target) ? $faa24f22a5163ec6$var$query(document, target) : target;
        $faa24f22a5163ec6$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $faa24f22a5163ec6$var$merge({
            label: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABEL) || "",
            labelledby: $faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$ARIA_LABELLEDBY) || ""
        }, $faa24f22a5163ec6$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $faa24f22a5163ec6$var$merge(options, JSON.parse($faa24f22a5163ec6$var$getAttribute(root, $faa24f22a5163ec6$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $faa24f22a5163ec6$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($faa24f22a5163ec6$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $faa24f22a5163ec6$var$assert(state.is([
            $faa24f22a5163ec6$var$CREATED,
            $faa24f22a5163ec6$var$DESTROYED
        ]), "Already mounted!");
        state.set($faa24f22a5163ec6$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($faa24f22a5163ec6$export$742b62a5690c060) ? $faa24f22a5163ec6$var$Fade : $faa24f22a5163ec6$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $faa24f22a5163ec6$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $faa24f22a5163ec6$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($faa24f22a5163ec6$export$d300dc1a2634364b);
        $faa24f22a5163ec6$var$addClass(this.root, $faa24f22a5163ec6$export$7761661e2d5b9388);
        state.set($faa24f22a5163ec6$var$IDLE);
        this.emit($faa24f22a5163ec6$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($faa24f22a5163ec6$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($faa24f22a5163ec6$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($faa24f22a5163ec6$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($faa24f22a5163ec6$var$CREATED)) $faa24f22a5163ec6$export$f188226459c8a3ff(this).on($faa24f22a5163ec6$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $faa24f22a5163ec6$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($faa24f22a5163ec6$export$88c4cf7419e470cd);
            event.destroy();
            completely && $faa24f22a5163ec6$var$empty(this.splides);
            state.set($faa24f22a5163ec6$var$DESTROYED);
        }
        return this;
    };
    $faa24f22a5163ec6$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $faa24f22a5163ec6$export$24494c7438c070bf = $faa24f22a5163ec6$var$_Splide;
$faa24f22a5163ec6$export$24494c7438c070bf.defaults = {};
$faa24f22a5163ec6$export$24494c7438c070bf.STATES = $faa24f22a5163ec6$var$STATES;
var $faa24f22a5163ec6$var$CLASS_RENDERED = "is-rendered";
var $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $faa24f22a5163ec6$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $faa24f22a5163ec6$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $faa24f22a5163ec6$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $faa24f22a5163ec6$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$export$f484e977a69c6ba6, defaults || {});
        $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge(this.options, $faa24f22a5163ec6$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $faa24f22a5163ec6$var$assign({}, $faa24f22a5163ec6$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $faa24f22a5163ec6$var$uniqueId("splide");
        this.Style = new $faa24f22a5163ec6$var$Style(this.id, this.options);
        this.Direction = $faa24f22a5163ec6$var$Direction(null, null, this.options);
        $faa24f22a5163ec6$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $faa24f22a5163ec6$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $faa24f22a5163ec6$var$queryAll(root, "." + $faa24f22a5163ec6$export$2c1ba4a4f1aa4947);
        on($faa24f22a5163ec6$export$d300dc1a2634364b, function() {
            $faa24f22a5163ec6$var$remove($faa24f22a5163ec6$var$child(root, "style"));
        });
        $faa24f22a5163ec6$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $faa24f22a5163ec6$var$push(this.slides, this.contents.map(function(content, index) {
            content = $faa24f22a5163ec6$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $faa24f22a5163ec6$export$72d36ecf3758cb4b : "");
            $faa24f22a5163ec6$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $faa24f22a5163ec6$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $faa24f22a5163ec6$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $faa24f22a5163ec6$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $faa24f22a5163ec6$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $faa24f22a5163ec6$var$unit(padding[prop] || ($faa24f22a5163ec6$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $faa24f22a5163ec6$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $faa24f22a5163ec6$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $faa24f22a5163ec6$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $faa24f22a5163ec6$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($faa24f22a5163ec6$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $faa24f22a5163ec6$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $faa24f22a5163ec6$var$merge($faa24f22a5163ec6$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $faa24f22a5163ec6$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $faa24f22a5163ec6$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $faa24f22a5163ec6$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $faa24f22a5163ec6$export$93b21159ad85c843,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.type,
            $faa24f22a5163ec6$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $faa24f22a5163ec6$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $faa24f22a5163ec6$export$93b21159ad85c843 + "--nav",
            $faa24f22a5163ec6$export$72d36ecf3758cb4b,
            !this.config.hidden && $faa24f22a5163ec6$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $faa24f22a5163ec6$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $faa24f22a5163ec6$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $faa24f22a5163ec6$var$forOwn(styles, function(value, key) {
            style += " " + $faa24f22a5163ec6$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$faa24f22a5163ec6$var$push(slides, slides);
        $faa24f22a5163ec6$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $faa24f22a5163ec6$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $faa24f22a5163ec6$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $faa24f22a5163ec6$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $faa24f22a5163ec6$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $faa24f22a5163ec6$var$SIZE + " " + $faa24f22a5163ec6$var$SIZE + '" width="' + $faa24f22a5163ec6$var$SIZE + '" height="' + $faa24f22a5163ec6$var$SIZE + '"><path d="' + (this.options.arrowPath || $faa24f22a5163ec6$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/*!
 * @splidejs/splide-extension-grid
 * Version  : 0.4.1
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ function $f7820c31cded84bf$var$empty$1(array) {
    array.length = 0;
}
function $f7820c31cded84bf$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $f7820c31cded84bf$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($f7820c31cded84bf$var$slice$1(arguments, 1)));
}
function $f7820c31cded84bf$var$typeOf$1(type, subject) {
    return typeof subject === type;
}
var $f7820c31cded84bf$var$isArray$1 = Array.isArray;
$f7820c31cded84bf$var$apply$1($f7820c31cded84bf$var$typeOf$1, "function");
$f7820c31cded84bf$var$apply$1($f7820c31cded84bf$var$typeOf$1, "string");
$f7820c31cded84bf$var$apply$1($f7820c31cded84bf$var$typeOf$1, "undefined");
function $f7820c31cded84bf$var$toArray$1(value) {
    return $f7820c31cded84bf$var$isArray$1(value) ? value : [
        value
    ];
}
function $f7820c31cded84bf$var$forEach$1(values, iteratee) {
    $f7820c31cded84bf$var$toArray$1(values).forEach(iteratee);
}
var $f7820c31cded84bf$var$ownKeys$1 = Object.keys;
function $f7820c31cded84bf$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $f7820c31cded84bf$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $f7820c31cded84bf$var$assign$1(object) {
    $f7820c31cded84bf$var$slice$1(arguments, 1).forEach(function(source) {
        $f7820c31cded84bf$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $f7820c31cded84bf$var$PROJECT_CODE$1 = "splide";
function $f7820c31cded84bf$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $f7820c31cded84bf$var$forEach$1(targets, function(target) {
            target && $f7820c31cded84bf$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $f7820c31cded84bf$var$empty$1(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $f7820c31cded84bf$var$EVENT_VISIBLE = "visible";
var $f7820c31cded84bf$var$EVENT_HIDDEN = "hidden";
var $f7820c31cded84bf$var$EVENT_REFRESH = "refresh";
var $f7820c31cded84bf$var$EVENT_UPDATED = "updated";
var $f7820c31cded84bf$var$EVENT_DESTROY = "destroy";
function $f7820c31cded84bf$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $f7820c31cded84bf$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $f7820c31cded84bf$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $f7820c31cded84bf$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $f7820c31cded84bf$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($f7820c31cded84bf$var$EVENT_DESTROY, binder.destroy);
    return $f7820c31cded84bf$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $f7820c31cded84bf$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
var $f7820c31cded84bf$var$CLASS_ROOT = $f7820c31cded84bf$var$PROJECT_CODE$1;
var $f7820c31cded84bf$var$CLASS_SLIDE = $f7820c31cded84bf$var$PROJECT_CODE$1 + "__slide";
var $f7820c31cded84bf$var$CLASS_CONTAINER = $f7820c31cded84bf$var$CLASS_SLIDE + "__container";
function $f7820c31cded84bf$var$empty(array) {
    array.length = 0;
}
function $f7820c31cded84bf$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $f7820c31cded84bf$var$apply(func) {
    return func.bind(null, ...$f7820c31cded84bf$var$slice(arguments, 1));
}
function $f7820c31cded84bf$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $f7820c31cded84bf$var$isObject(subject) {
    return !$f7820c31cded84bf$var$isNull(subject) && $f7820c31cded84bf$var$typeOf("object", subject);
}
const $f7820c31cded84bf$var$isArray = Array.isArray;
$f7820c31cded84bf$var$apply($f7820c31cded84bf$var$typeOf, "function");
const $f7820c31cded84bf$var$isString = $f7820c31cded84bf$var$apply($f7820c31cded84bf$var$typeOf, "string");
const $f7820c31cded84bf$var$isUndefined = $f7820c31cded84bf$var$apply($f7820c31cded84bf$var$typeOf, "undefined");
function $f7820c31cded84bf$var$isNull(subject) {
    return subject === null;
}
function $f7820c31cded84bf$var$isHTMLElement(subject) {
    return subject instanceof HTMLElement;
}
function $f7820c31cded84bf$var$toArray(value) {
    return $f7820c31cded84bf$var$isArray(value) ? value : [
        value
    ];
}
function $f7820c31cded84bf$var$forEach(values, iteratee) {
    $f7820c31cded84bf$var$toArray(values).forEach(iteratee);
}
function $f7820c31cded84bf$var$push(array, items) {
    array.push(...$f7820c31cded84bf$var$toArray(items));
    return array;
}
function $f7820c31cded84bf$var$toggleClass(elm, classes, add) {
    if (elm) $f7820c31cded84bf$var$forEach(classes, (name)=>{
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $f7820c31cded84bf$var$addClass(elm, classes) {
    $f7820c31cded84bf$var$toggleClass(elm, $f7820c31cded84bf$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $f7820c31cded84bf$var$append(parent, children) {
    $f7820c31cded84bf$var$forEach(children, parent.appendChild.bind(parent));
}
function $f7820c31cded84bf$var$matches(elm, selector) {
    return $f7820c31cded84bf$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $f7820c31cded84bf$var$children(parent, selector) {
    const children2 = parent ? $f7820c31cded84bf$var$slice(parent.children) : [];
    return selector ? children2.filter((child)=>$f7820c31cded84bf$var$matches(child, selector)) : children2;
}
function $f7820c31cded84bf$var$child(parent, selector) {
    return selector ? $f7820c31cded84bf$var$children(parent, selector)[0] : parent.firstElementChild;
}
const $f7820c31cded84bf$var$ownKeys = Object.keys;
function $f7820c31cded84bf$var$forOwn(object, iteratee, right) {
    if (object) {
        let keys = $f7820c31cded84bf$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $f7820c31cded84bf$var$assign(object) {
    $f7820c31cded84bf$var$slice(arguments, 1).forEach((source)=>{
        $f7820c31cded84bf$var$forOwn(source, (value, key)=>{
            object[key] = source[key];
        });
    });
    return object;
}
function $f7820c31cded84bf$var$omit(object, keys) {
    $f7820c31cded84bf$var$toArray(keys || $f7820c31cded84bf$var$ownKeys(object)).forEach((key)=>{
        delete object[key];
    });
}
function $f7820c31cded84bf$var$removeAttribute(elms, attrs) {
    $f7820c31cded84bf$var$forEach(elms, (elm)=>{
        $f7820c31cded84bf$var$forEach(attrs, (attr)=>{
            elm && elm.removeAttribute(attr);
        });
    });
}
function $f7820c31cded84bf$var$setAttribute(elms, attrs, value) {
    if ($f7820c31cded84bf$var$isObject(attrs)) $f7820c31cded84bf$var$forOwn(attrs, (value2, name)=>{
        $f7820c31cded84bf$var$setAttribute(elms, name, value2);
    });
    else $f7820c31cded84bf$var$forEach(elms, (elm)=>{
        $f7820c31cded84bf$var$isNull(value) || value === "" ? $f7820c31cded84bf$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $f7820c31cded84bf$var$create(tag, attrs, parent) {
    const elm = document.createElement(tag);
    if (attrs) $f7820c31cded84bf$var$isString(attrs) ? $f7820c31cded84bf$var$addClass(elm, attrs) : $f7820c31cded84bf$var$setAttribute(elm, attrs);
    parent && $f7820c31cded84bf$var$append(parent, elm);
    return elm;
}
function $f7820c31cded84bf$var$style(elm, prop, value) {
    if ($f7820c31cded84bf$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$f7820c31cded84bf$var$isNull(value)) elm.style[prop] = `${value}`;
}
function $f7820c31cded84bf$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $f7820c31cded84bf$var$remove(nodes) {
    $f7820c31cded84bf$var$forEach(nodes, (node)=>{
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $f7820c31cded84bf$var$queryAll(parent, selector) {
    return selector ? $f7820c31cded84bf$var$slice(parent.querySelectorAll(selector)) : [];
}
function $f7820c31cded84bf$var$removeClass(elm, classes) {
    $f7820c31cded84bf$var$toggleClass(elm, classes, false);
}
function $f7820c31cded84bf$var$unit(value) {
    return $f7820c31cded84bf$var$isString(value) ? value : value ? `${value}px` : "";
}
const $f7820c31cded84bf$var$PROJECT_CODE = "splide";
function $f7820c31cded84bf$var$assert(condition, message) {
    if (!condition) throw new Error(`[${$f7820c31cded84bf$var$PROJECT_CODE}] ${message || ""}`);
}
const { min: $f7820c31cded84bf$var$min, max: $f7820c31cded84bf$var$max, floor: $f7820c31cded84bf$var$floor, ceil: $f7820c31cded84bf$var$ceil, abs: $f7820c31cded84bf$var$abs } = Math;
function $f7820c31cded84bf$var$pad(number) {
    return number < 10 ? `0${number}` : `${number}`;
}
const $f7820c31cded84bf$var$CLASS_SLIDE_ROW = `${$f7820c31cded84bf$var$CLASS_SLIDE}__row`;
const $f7820c31cded84bf$var$CLASS_SLIDE_COL = `${$f7820c31cded84bf$var$CLASS_SLIDE}--col`;
const $f7820c31cded84bf$var$DEFAULTS = {
    rows: 1,
    cols: 1,
    dimensions: [],
    gap: {}
};
function $f7820c31cded84bf$var$Dimension(options) {
    function normalize() {
        const { rows: rows, cols: cols, dimensions: dimensions } = options;
        return $f7820c31cded84bf$var$isArray(dimensions) && dimensions.length ? dimensions : [
            [
                rows,
                cols
            ]
        ];
    }
    function get(index) {
        const dimensions = normalize();
        return dimensions[$f7820c31cded84bf$var$min(index, dimensions.length - 1)];
    }
    function getAt(index) {
        const dimensions = normalize();
        let rows, cols, aggregator = 0;
        for(let i = 0; i < dimensions.length; i++){
            const dimension = dimensions[i];
            rows = dimension[0] || 1;
            cols = dimension[1] || 1;
            aggregator += rows * cols;
            if (index < aggregator) break;
        }
        $f7820c31cded84bf$var$assert(rows && cols, "Invalid dimension");
        return [
            rows,
            cols
        ];
    }
    return {
        get: get,
        getAt: getAt
    };
}
function $f7820c31cded84bf$var$Layout(Splide2, gridOptions, Dimension) {
    const { on: on, destroy: destroyEvent } = $f7820c31cded84bf$var$EventInterface(Splide2);
    const { Components: Components, options: options } = Splide2;
    const { resolve: resolve } = Components.Direction;
    const { forEach: forEach } = Components.Slides;
    function mount() {
        layout();
        if (options.slideFocus) {
            on($f7820c31cded84bf$var$EVENT_VISIBLE, onVisible);
            on($f7820c31cded84bf$var$EVENT_HIDDEN, onHidden);
        }
    }
    function destroy() {
        forEach((Slide)=>{
            const { slide: slide } = Slide;
            toggleTabIndex(slide, false);
            getRowsIn(slide).forEach((cell)=>{
                $f7820c31cded84bf$var$removeAttribute(cell, "style");
            });
            getColsIn(slide).forEach((colSlide)=>{
                cover(colSlide, true);
                $f7820c31cded84bf$var$removeAttribute(colSlide, "style");
            });
        });
        destroyEvent();
    }
    function layout() {
        forEach((Slide)=>{
            const { slide: slide } = Slide;
            const [rows, cols] = Dimension.get(Slide.isClone ? Slide.slideIndex : Slide.index);
            layoutRow(rows, slide);
            layoutCol(cols, slide);
            getColsIn(Slide.slide).forEach((colSlide, index)=>{
                colSlide.id = `${Slide.slide.id}-col${$f7820c31cded84bf$var$pad(index + 1)}`;
                if (Splide2.options.cover) cover(colSlide);
            });
        });
    }
    function layoutRow(rows, slide) {
        const { row: rowGap } = gridOptions.gap;
        const height = `calc(${100 / rows}%${rowGap ? ` - ${$f7820c31cded84bf$var$unit(rowGap)} * ${(rows - 1) / rows}` : ""})`;
        getRowsIn(slide).forEach((rowElm, index, rowElms)=>{
            $f7820c31cded84bf$var$style(rowElm, "height", height);
            $f7820c31cded84bf$var$style(rowElm, "display", "flex");
            $f7820c31cded84bf$var$style(rowElm, "margin", `0 0 ${$f7820c31cded84bf$var$unit(rowGap)} 0`);
            $f7820c31cded84bf$var$style(rowElm, "padding", 0);
            if (index === rowElms.length - 1) $f7820c31cded84bf$var$style(rowElm, "marginBottom", 0);
        });
    }
    function layoutCol(cols, slide) {
        const { col: colGap } = gridOptions.gap;
        const width = `calc(${100 / cols}%${colGap ? ` - ${$f7820c31cded84bf$var$unit(colGap)} * ${(cols - 1) / cols}` : ""})`;
        getColsIn(slide).forEach((colElm, index, colElms)=>{
            $f7820c31cded84bf$var$style(colElm, "width", width);
            if (index !== colElms.length - 1) $f7820c31cded84bf$var$style(colElm, resolve("marginRight"), $f7820c31cded84bf$var$unit(colGap));
        });
    }
    function cover(colSlide, uncover) {
        const container = $f7820c31cded84bf$var$child(colSlide, `.${$f7820c31cded84bf$var$CLASS_CONTAINER}`);
        const img = $f7820c31cded84bf$var$child(container || colSlide, "img");
        if (img && img.src) {
            $f7820c31cded84bf$var$style(container || colSlide, "background", uncover ? "" : `center/cover no-repeat url("${img.src}")`);
            $f7820c31cded84bf$var$style(img, "display", uncover ? "" : "none");
        }
    }
    function getRowsIn(slide) {
        return $f7820c31cded84bf$var$queryAll(slide, `.${$f7820c31cded84bf$var$CLASS_SLIDE_ROW}`);
    }
    function getColsIn(slide) {
        return $f7820c31cded84bf$var$queryAll(slide, `.${$f7820c31cded84bf$var$CLASS_SLIDE_COL}`);
    }
    function toggleTabIndex(slide, add) {
        getColsIn(slide).forEach((colSlide)=>{
            $f7820c31cded84bf$var$setAttribute(colSlide, "tabindex", add ? 0 : null);
        });
    }
    function onVisible(Slide) {
        toggleTabIndex(Slide.slide, true);
    }
    function onHidden(Slide) {
        toggleTabIndex(Slide.slide, false);
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $f7820c31cded84bf$export$ef2184bd89960b14(Splide2, Components2, options) {
    const { on: on, off: off } = $f7820c31cded84bf$var$EventInterface(Splide2);
    const { Elements: Elements } = Components2;
    const gridOptions = {};
    const Dimension$1 = $f7820c31cded84bf$var$Dimension(gridOptions);
    const Layout$1 = $f7820c31cded84bf$var$Layout(Splide2, gridOptions, Dimension$1);
    const modifier = `${$f7820c31cded84bf$var$CLASS_ROOT}--grid`;
    const originalSlides = [];
    function mount() {
        init();
        on($f7820c31cded84bf$var$EVENT_UPDATED, init);
    }
    function init() {
        $f7820c31cded84bf$var$omit(gridOptions);
        $f7820c31cded84bf$var$assign(gridOptions, $f7820c31cded84bf$var$DEFAULTS, options.grid || {});
        if (shouldBuild()) {
            destroy();
            $f7820c31cded84bf$var$push(originalSlides, Elements.slides);
            $f7820c31cded84bf$var$addClass(Splide2.root, modifier);
            $f7820c31cded84bf$var$append(Elements.list, build());
            off($f7820c31cded84bf$var$EVENT_REFRESH);
            on($f7820c31cded84bf$var$EVENT_REFRESH, layout);
            refresh();
        } else if (isActive()) {
            destroy();
            refresh();
        }
    }
    function destroy() {
        if (isActive()) {
            const { slides: slides } = Elements;
            Layout$1.destroy();
            originalSlides.forEach((slide)=>{
                $f7820c31cded84bf$var$removeClass(slide, $f7820c31cded84bf$var$CLASS_SLIDE_COL);
                $f7820c31cded84bf$var$append(Elements.list, slide);
            });
            $f7820c31cded84bf$var$remove(slides);
            $f7820c31cded84bf$var$removeClass(Splide2.root, modifier);
            $f7820c31cded84bf$var$empty(slides);
            $f7820c31cded84bf$var$push(slides, originalSlides);
            $f7820c31cded84bf$var$empty(originalSlides);
            off($f7820c31cded84bf$var$EVENT_REFRESH);
        }
    }
    function refresh() {
        Splide2.refresh();
    }
    function layout() {
        if (isActive()) Layout$1.mount();
    }
    function build() {
        const outerSlides = [];
        let row = 0, col = 0;
        let outerSlide, rowSlide;
        originalSlides.forEach((slide, index)=>{
            const [rows, cols] = Dimension$1.getAt(index);
            if (!col) {
                if (!row) {
                    outerSlide = $f7820c31cded84bf$var$create(slide.tagName, $f7820c31cded84bf$var$CLASS_SLIDE);
                    outerSlides.push(outerSlide);
                }
                rowSlide = buildRow(rows, slide, outerSlide);
            }
            buildCol(cols, slide, rowSlide);
            if (++col >= cols) {
                col = 0;
                row = ++row >= rows ? 0 : row;
            }
        });
        return outerSlides;
    }
    function buildRow(rows, slide, outerSlide) {
        const tag = slide.tagName.toLowerCase() === "li" ? "ul" : "div";
        return $f7820c31cded84bf$var$create(tag, $f7820c31cded84bf$var$CLASS_SLIDE_ROW, outerSlide);
    }
    function buildCol(cols, slide, rowSlide) {
        $f7820c31cded84bf$var$addClass(slide, $f7820c31cded84bf$var$CLASS_SLIDE_COL);
        $f7820c31cded84bf$var$append(rowSlide, slide);
        return slide;
    }
    function shouldBuild() {
        if (options.grid) {
            const { rows: rows, cols: cols, dimensions: dimensions } = gridOptions;
            return rows > 1 || cols > 1 || $f7820c31cded84bf$var$isArray(dimensions) && dimensions.length > 0;
        }
        return false;
    }
    function isActive() {
        return $f7820c31cded84bf$var$hasClass(Splide2.root, modifier);
    }
    return {
        mount: mount,
        destroy: destroy
    };
}



const $c2451cd7f9fe8fd7$var$sliders = {
    init () {
        this.heroSlider();
        this.catSlider();
        this.prodSlider();
        this.setProdThumbnailsSlider();
        this.showcaseSlider();
        this.resetSlider();
    },
    resetSlider () {
        window.addEventListener("reset", ()=>{
            this.setProdThumbnailsSlider();
        });
    },
    heroSlider () {
        const heroSliders = document.querySelectorAll(".jsHeroSlider");
        heroSliders.forEach((el)=>{
            const loadSlideImage = (slide)=>{
                if (!slide || slide.dataset.imageLoaded === "true") return;
                const img = slide.querySelector("img[data-src]");
                if (!img) {
                    slide.dataset.imageLoaded = "true";
                    return;
                }
                const dataSrc = img.getAttribute("data-src");
                if (!dataSrc) return;
                img.src = dataSrc;
                img.removeAttribute("data-src");
                slide.dataset.imageLoaded = "true";
            };
            const slider = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(el, {
                type: "loop",
                perPage: 1,
                pagination: false,
                arrows: true,
                autoplay: true,
                speed: 600,
                interval: 5000,
                reducedMotion: {
                    interval: 5000,
                    speed: 600,
                    autoplay: true
                }
            });
            slider.on("mounted move", ()=>{
                const activeSlide = el.querySelector(".splide__slide.is-active");
                const prevSlide = el.querySelector(".splide__slide.is-prev");
                const nextSlide = el.querySelector(".splide__slide.is-next");
                loadSlideImage(activeSlide);
                loadSlideImage(prevSlide);
                loadSlideImage(nextSlide);
            });
            slider.mount();
        });
    },
    showcaseSlider () {
        const showcaseSliders = document.querySelectorAll(".jsShowcaseSlider");
        showcaseSliders.forEach((item)=>{
            const slider = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(item, {
                type: "loop",
                perPage: 1,
                perMove: 1,
                arrows: false,
                pagination: false,
                gap: 25,
                grid: {
                    rows: 2,
                    cols: 3,
                    gap: {
                        row: "25px",
                        col: "25px"
                    }
                },
                breakpoints: {
                    1200: {
                        grid: {
                            rows: 3,
                            cols: 2,
                            gap: {
                                row: "25px",
                                col: "25px"
                            }
                        }
                    }
                }
            });
            slider.mount({
                Grid: $f7820c31cded84bf$export$ef2184bd89960b14
            });
        });
    },
    catSlider () {
        const sliders = document.querySelectorAll(".jsCatSlider");
        sliders.forEach((item)=>{
            new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(item, {
                type: "loop",
                pagination: true,
                arrows: false,
                autoplay: true,
                speed: 800,
                destroy: true,
                breakpoints: {
                    1200: {
                        destroy: false,
                        perPage: 2,
                        gap: 20,
                        padding: {
                            right: "30%"
                        }
                    }
                }
            }).mount();
        });
    },
    prodSlider () {
        const sliders = document.querySelectorAll(".jsProdSlider");
        sliders.forEach((item)=>{
            new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(item, {
                type: "carousel",
                arrows: true,
                pagination: false,
                destroy: true,
                breakpoints: {
                    1200: {
                        destroy: false,
                        perPage: 1,
                        grid: {
                            rows: 2,
                            cols: 3,
                            gap: {
                                row: "20px",
                                col: "20px"
                            }
                        }
                    },
                    768: {
                        grid: {
                            rows: 2,
                            cols: 2,
                            gap: {
                                row: "7px",
                                col: "7px"
                            }
                        }
                    }
                }
            }).mount({
                Grid: $f7820c31cded84bf$export$ef2184bd89960b14
            });
        });
    },
    setProdThumbnailsSlider () {
        const porductMainImages = document.getElementById("mainImage");
        const thumbnails = document.getElementById("thumbnails");
        if (porductMainImages && thumbnails) {
            const main = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(porductMainImages, {
                type: "fade",
                rewind: true,
                pagination: false,
                arrows: true,
                breakpoints: {
                    1199: {}
                }
            });
            const thumbnailsNav = new (0, $faa24f22a5163ec6$export$24494c7438c070bf)(thumbnails, {
                direction: "ttb",
                isNavigation: true,
                pagination: false,
                fixedHeight: "60px",
                heightRatio: 6,
                perPage: 4,
                arrows: true,
                gap: "30px",
                breakpoints: {}
            });
            main.sync(thumbnailsNav);
            main.mount();
            thumbnailsNav.mount();
        }
    }
};
var $c2451cd7f9fe8fd7$export$2e2bcd8739ae039 = $c2451cd7f9fe8fd7$var$sliders;


const $d4e2d81e80d5910a$var$mobMenu = {
    nextLevel: document.querySelectorAll(".jsNextLevel"),
    prevLevel: document.querySelectorAll(".jsPrevLevel"),
    close: document.getElementById("jsCloseMenu"),
    init () {
        this.setNextLevel();
        this.setPrevLevel();
    },
    setNextLevel () {
        this.nextLevel.forEach((item)=>{
            const subMenu = item.nextElementSibling;
            if (subMenu) item.addEventListener("click", (e)=>{
                e.preventDefault();
                subMenu.classList.add("activeClass");
            });
            this.close.addEventListener("click", ()=>{
                subMenu.classList.remove("activeClass");
            });
        });
    },
    setPrevLevel () {
        this.prevLevel.forEach((item)=>{
            const menu = item.parentElement?.parentElement;
            if (menu) item.addEventListener("click", ()=>{
                menu?.classList.remove("activeClass");
            });
            this.close.addEventListener("click", ()=>{
                menu?.classList.remove("activeClass");
            });
        });
    }
};
var $d4e2d81e80d5910a$export$2e2bcd8739ae039 = $d4e2d81e80d5910a$var$mobMenu;


const $314b550233ac0c7d$var$readMore = {
    wrap: document.querySelectorAll(".jsReadMore"),
    init () {
        this.setBtn();
    },
    setBtn () {
        this.wrap.forEach((item)=>{
            const elWrap = item.querySelector(".jsReadMoreWrap");
            const elBody = item.querySelector(".jsReadMoreBody");
            const btn = item.querySelector(".jsReadMoreTrigger");
            const height = elBody.offsetHeight;
            const itemHeight = elWrap.offsetHeight;
            if (!btn) return;
            if (height <= itemHeight) btn.classList.add("d-none");
            btn.addEventListener("click", ()=>{
                if (btn.dataset.open === "false") {
                    btn.dataset.open = "true";
                    elWrap.style.maxHeight = height + 30 + "px";
                    btn.innerHTML = 'View Less <svg> <use xlink:href="#icon-chevron-down" /></svg>';
                } else {
                    btn.dataset.open = "false";
                    elWrap.style.maxHeight = itemHeight + "px";
                    btn.innerHTML = 'View More <svg> <use xlink:href="#icon-chevron-down" /></svg>';
                }
            });
        });
    }
};
var $314b550233ac0c7d$export$2e2bcd8739ae039 = $314b550233ac0c7d$var$readMore;



const $61e60b05d877614a$var$accordian = {
    accordian: document.querySelectorAll(".jsAccordian"),
    scrollToEl: undefined,
    init () {
        this.setAccordian();
    },
    setAccordian () {
        this.accordian.forEach((item)=>{
            const width = item.dataset.width ? item.dataset.width : "999999";
            const offset = item.dataset.offset;
            if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) < parseInt(width)) {
                const items = item.querySelectorAll(".jsAccordianItem");
                this.setItems(items);
                this.setMultipleToggle(item, items);
                if (offset) item.addEventListener("transitionend", ()=>{
                    this.scrollPosition(offset);
                });
            }
        });
    },
    setItems (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const sibiling = item.nextElementSibling;
            const sibilingHeight = sibiling.offsetHeight;
            const height = item.offsetHeight;
            if (item.dataset.open === "true") {
                parent.style.maxHeight = height + sibilingHeight + "px";
                item.classList.add("activeClass");
            }
            item.addEventListener("click", (e)=>{
                e.preventDefault();
                if (item.dataset.open === "false") {
                    this.scrollToEl = parent;
                    item.dataset.open = "true";
                    parent.style.maxHeight = height + sibilingHeight + "px";
                    item.classList.add("activeClass");
                } else {
                    this.scrollToEl = undefined;
                    item.dataset.open = "false";
                    parent.style.maxHeight = height + "px";
                    item.classList.remove("activeClass");
                }
            });
        });
    },
    setMultipleToggle (item, items) {
        const expendAll = item.querySelector(".jsAccordianExpandOpenAll");
        const closeAll = item.querySelector(".jsAccordianCollapseAll");
        expendAll?.addEventListener("click", ()=>{
            expendAll.classList.add("activeClass");
            closeAll?.classList.remove("activeClass");
            this.openAll(items);
        });
        expendAll?.click();
        closeAll?.addEventListener("click", ()=>{
            closeAll.classList.add("activeClass");
            expendAll?.classList.remove("activeClass");
            this.closeAll(items);
        });
    },
    closeAll (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const height = item.offsetHeight;
            item.dataset.open = "false";
            parent.style.maxHeight = height + "px";
            item.classList.remove("activeClass");
        });
    },
    openAll (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const sibiling = item.nextElementSibling;
            const sibilingHeight = sibiling.offsetHeight;
            const height = item.offsetHeight;
            item.dataset.open = "true";
            parent.style.maxHeight = height + sibilingHeight + "px";
            item.classList.add("activeClass");
        });
    },
    scrollPosition (offset) {
        if (this.scrollToEl) window.scrollTo({
            top: this.scrollToEl.offsetTop - +offset,
            behavior: "smooth"
        });
    }
};
var $61e60b05d877614a$export$2e2bcd8739ae039 = $61e60b05d877614a$var$accordian;


const $0d2d2f0cba207d42$var$headerPopups = {
    accountBtn: document.getElementById("jsUserBtn"),
    accountWrap: document.getElementById("jsUserWrap"),
    cartBtn: document.getElementById("jsCartBtn"),
    cartWrap: document.getElementById("jsCartWrap"),
    helpBtn: document.getElementById("jsHelpBtn"),
    helpWrap: document.getElementById("jsHelpWrap"),
    init () {
        this.setHoverState();
        this.removeHoverState();
    },
    setHoverState () {
        this.accountBtn.addEventListener("mouseenter", this.handleAccountHover.bind(this));
        this.cartBtn.addEventListener("mouseenter", this.handleCartHover.bind(this));
        this.helpBtn.addEventListener("mouseenter", this.handleHelpHover.bind(this));
    },
    handleAccountHover () {
        this.accountWrap.classList.add("activeClass");
        this.cartWrap.classList.remove("activeClass");
        this.helpWrap.classList.remove("activeClass");
    },
    handleCartHover () {
        this.cartWrap.classList.add("activeClass");
        this.accountWrap.classList.remove("activeClass");
        this.helpWrap.classList.remove("activeClass");
    },
    handleHelpHover () {
        this.helpWrap.classList.add("activeClass");
        this.accountWrap.classList.remove("activeClass");
        this.cartWrap.classList.remove("activeClass");
    },
    removeHoverState () {
        window.addEventListener("mouseover", this.handleMouseOut.bind(this));
    },
    handleMouseOut (e) {
        const target = e.target;
        if (!this.isHoveredElement(target)) {
            this.accountWrap.classList.remove("activeClass");
            this.cartWrap.classList.remove("activeClass");
            this.helpWrap.classList.remove("activeClass");
        }
    },
    isHoveredElement (target) {
        return [
            this.accountBtn,
            this.accountWrap,
            this.cartBtn,
            this.cartWrap,
            this.helpBtn,
            this.helpWrap
        ].some((element)=>element === target || element.contains(target));
    }
};
var $0d2d2f0cba207d42$export$2e2bcd8739ae039 = $0d2d2f0cba207d42$var$headerPopups;



const $1930f24e3c858708$var$megamenu = {
    links: document.querySelectorAll(".desc-nav__item"),
    init () {
        if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) >= 1649) this.getPosition();
        this.resizePosition();
    },
    getPosition () {
        this.links.forEach((item)=>{
            const megamenu = item.querySelector(".desc-nav__sublist");
            if (!megamenu) return;
            const wrapElement = document.querySelector(".desc-nav__wrap");
            if (!wrapElement) return;
            const bounding = item.getBoundingClientRect();
            const wrapBounding = wrapElement.getBoundingClientRect();
            const megamenuWidth = megamenu.offsetWidth;
            if (bounding.left + megamenuWidth / 2 <= wrapBounding.right && bounding.right - megamenuWidth / 2 >= wrapBounding.left) {
                megamenu.style.left = "50%";
                megamenu.style.transform = "translateX(-50%)";
            } else {
                megamenu.style.left = "0";
                megamenu.style.transform = "none";
                const megamenuRightEdge = bounding.left + megamenuWidth;
                if (megamenuRightEdge > wrapBounding.right) {
                    const overflowAmount = megamenuRightEdge - wrapBounding.right;
                    megamenu.style.left = `-${overflowAmount}px`;
                }
                const megamenuLeftEdge = bounding.left;
                if (megamenuLeftEdge < wrapBounding.left) {
                    const underflowAmount = wrapBounding.left - megamenuLeftEdge;
                    megamenu.style.left = `${underflowAmount}px`;
                }
            }
        });
    },
    resizePosition () {
        window.addEventListener("resize", ()=>{
            this.getPosition();
        });
    }
};
var $1930f24e3c858708$export$2e2bcd8739ae039 = $1930f24e3c858708$var$megamenu;


const $fecaf8c6db57680a$var$stickyHeader = {
    header: document.getElementById("jsStickyHeader"),
    mainContent: document.getElementById("main-content"),
    popups: document.querySelectorAll(".jsStickyPopup"),
    lastScrollTop: 0,
    init () {
        this.setClass();
    },
    setClass () {
        document.addEventListener("scroll", ()=>{
            const st = window.scrollY || document.documentElement.scrollTop;
            if (st > this.lastScrollTop) {
                this.header.classList.remove("up");
                this.header.classList.add("down");
                this.mainContent.classList.remove("up");
                this.mainContent.classList.add("down");
                this.popups.forEach((popup)=>{
                    popup.classList.add("activeScroll");
                });
            } else {
                this.header.classList.add("up");
                this.header.classList.remove("down");
                this.mainContent.classList.add("up");
                this.mainContent.classList.remove("down");
                this.popups.forEach((popup)=>{
                    popup.classList.add("activeScroll");
                });
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
            if (window.scrollY === 0) {
                this.header.classList.remove("up");
                this.header.classList.remove("down");
                this.mainContent.classList.remove("up");
                this.mainContent.classList.remove("down");
                this.popups.forEach((popup)=>{
                    popup.classList.remove("activeScroll");
                });
            }
        });
    }
};
var $fecaf8c6db57680a$export$2e2bcd8739ae039 = $fecaf8c6db57680a$var$stickyHeader;


const $66a6452774c8b5f2$var$showHideFilters = {
    filterWrap: document.querySelectorAll(".jsFilterWrap"),
    init () {
        this.toggleFilters();
    },
    toggleFilters () {
        this.filterWrap.forEach((filter)=>{
            const singleFilters = filter.querySelectorAll(".jsFilter");
            const btns = filter.querySelector(".jsShowMore");
            if (singleFilters.length > 8 && btns) {
                filter.classList.add("filter-less");
                if (btns.style) btns.style.display = "block";
            } else if (btns && btns.style) btns.style.display = "none";
            if (btns) btns.addEventListener("click", ()=>{
                filter.classList.toggle("filter-less");
                filter.style.height = filter.classList.contains("filter-less") ? "auto" : "auto";
                if (btns.textContent) btns.textContent = filter.classList.contains("filter-less") ? "View More +" : "View Less -";
            });
        });
    }
};
var $66a6452774c8b5f2$export$2e2bcd8739ae039 = $66a6452774c8b5f2$var$showHideFilters;



const $69333880e753ba80$var$showHideProducts = {
    filterWrap: document.querySelectorAll(".jsProdWrap"),
    init () {
        if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) > 1199) this.toggleFilters();
    },
    toggleFilters () {
        this.filterWrap.forEach((filter)=>{
            const singleFilters = filter.querySelectorAll(".jsProd");
            const btns = filter.querySelector(".jsShowMore");
            if (singleFilters.length > 4 && btns) {
                filter.classList.add("filter-less");
                if (btns.style) btns.style.display = "block";
            } else if (btns && btns.style) btns.style.display = "none";
            if (btns) btns.addEventListener("click", ()=>{
                filter.classList.toggle("filter-less");
                filter.style.height = filter.classList.contains("filter-less") ? "auto" : "auto";
                if (btns.textContent) btns.textContent = filter.classList.contains("filter-less") ? "Show More +" : "Show Less -";
            });
        });
    }
};
var $69333880e753ba80$export$2e2bcd8739ae039 = $69333880e753ba80$var$showHideProducts;



const $7f7b779d59f7c599$var$scrollCart = {
    cartLine: document.getElementById("addToCartLine"),
    cartBtn: document.querySelector(".jsInView"),
    init () {
        window.addEventListener("DOMContentLoaded", this.setScroll.bind(this));
        window.addEventListener("reset", this.setScroll.bind(this));
        window.addEventListener("scroll", this.setScroll.bind(this));
    },
    setScroll () {
        if (this.cartBtn && (0, $33151c6d3bf6cc96$export$62976f5619263b39)(this.cartBtn)) this.cartLine?.classList.add("activeClass");
        else this.cartLine?.classList.remove("activeClass");
    }
};
var $7f7b779d59f7c599$export$2e2bcd8739ae039 = $7f7b779d59f7c599$var$scrollCart;


const $38b4613e8924b4cd$var$scrollMenu = {
    init () {
        this.setScroll();
    },
    setScroll () {
        const slider = document.getElementById("jsScrollMenu");
        let isDown = false;
        let startX;
        let scrollLeft;
        if (slider) {
            // Disable scrolling when clicking on links
            const menuLinks = slider.querySelectorAll("a");
            menuLinks.forEach((link)=>{
                link.addEventListener("mousedown", (e)=>{
                    e.stopPropagation(); // Prevent the scroll from being triggered
                });
            });
            // Scroll functionality when clicking on the menu (not on links)
            slider.addEventListener("mousedown", (e)=>{
                if (e.target instanceof HTMLAnchorElement) return; // Do nothing if the click is on a link
                isDown = true;
                slider.classList.add("active");
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener("mouseleave", ()=>{
                isDown = false;
                slider.classList.remove("active");
            });
            slider.addEventListener("mouseup", ()=>{
                isDown = false;
                slider.classList.remove("active");
            });
            slider.addEventListener("mousemove", (e)=>{
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 1;
                slider.scrollLeft = scrollLeft - walk;
            });
        }
    }
};
var $38b4613e8924b4cd$export$2e2bcd8739ae039 = $38b4613e8924b4cd$var$scrollMenu;



const $ef8c1b6e7434ea63$var$stickySidebar = {
    wrap: document.getElementById("jsProdWrap"),
    parent: document.querySelector(".product__wrap"),
    init () {
        if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) > 1200) this.setSticky();
    },
    setSticky () {
        window.addEventListener("scroll", ()=>{
            const stickyRect = this.wrap.getBoundingClientRect();
            const containerRect = this.parent.getBoundingClientRect();
            if (stickyRect.bottom >= containerRect.bottom) this.wrap.style.top = `150px`;
            if (stickyRect.top <= containerRect.top) this.wrap.style.top = `60px`;
        });
    }
};
var $ef8c1b6e7434ea63$export$2e2bcd8739ae039 = $ef8c1b6e7434ea63$var$stickySidebar;


const $7908104f9fbf8ae1$var$thumbHeight = {
    thumbs: document.querySelectorAll(".product-box__title"),
    observer: null,
    init () {
        this.refreshTitles();
        this.checkExpandableTitles();
        this.observeProducts();
        window.addEventListener("resize", ()=>{
            this.refreshTitles();
            this.checkExpandableTitles();
        });
    },
    refreshTitles () {
        this.thumbs = document.querySelectorAll(".product-box__title");
    },
    checkExpandableTitles () {
        if (window.innerWidth < 1200) {
            this.thumbs.forEach((item)=>{
                item.classList.remove("is-expandable");
            });
            return;
        }
        this.thumbs.forEach((item)=>{
            const card = item.closest(".product-box");
            if (!card) return;
            /*
       * Skip cards that are currently hidden.
       * They will be checked once they become visible.
       */ if (card.offsetParent === null) {
                item.classList.remove("is-expandable");
                return;
            }
            item.classList.remove("is-expandable");
            const clampedHeight = item.clientHeight;
            const webkitLineClamp = item.style.webkitLineClamp;
            const overflow = item.style.overflow;
            const display = item.style.display;
            const height = item.style.height;
            /*
       * Temporarily remove the clamp/fixed height
       * so we can measure the full title.
       */ item.style.webkitLineClamp = "unset";
            item.style.overflow = "visible";
            item.style.display = "block";
            item.style.height = "auto";
            const fullHeight = item.scrollHeight;
            /*
       * Restore original inline styles.
       */ item.style.webkitLineClamp = webkitLineClamp;
            item.style.overflow = overflow;
            item.style.display = display;
            item.style.height = height;
            item.classList.toggle("is-expandable", fullHeight > clampedHeight + 1);
        });
    },
    observeProducts () {
        this.observer = new MutationObserver(()=>{
            requestAnimationFrame(()=>{
                this.refreshTitles();
                this.checkExpandableTitles();
            });
        });
        document.querySelectorAll(".products-list, .product-box").forEach((element)=>{
            this.observer?.observe(element, {
                attributes: true,
                attributeFilter: [
                    "class",
                    "style"
                ],
                childList: true,
                subtree: true
            });
        });
    }
};
var $7908104f9fbf8ae1$export$2e2bcd8739ae039 = $7908104f9fbf8ae1$var$thumbHeight;


class $5faf9ae567940230$export$129a32eedafa97c5 {
    constructor(popup, triger, close){
        this.popup = null;
        this.triger = null;
        this.close = null;
        this.overlay = document.getElementById("overlay");
        this.isOpen = false;
        this.popup = document.querySelector(popup);
        this.triger = document.querySelectorAll(triger);
        this.close = document.querySelectorAll(close);
    }
    recunstruct(popup, triger, close) {
        this.reset();
        if (popup) {
            this.popup = document.querySelector(popup);
            this.popup?.classList.add("init");
        }
        if (triger) this.triger = document.querySelectorAll(triger);
        if (close) this.close = document.querySelectorAll(close);
    }
    init() {
        this.popup?.classList.add("init");
        this.openPopup();
        this.overlayClose();
        this.setClose();
        this.resetSlider();
    }
    reset() {
        if (this.popup && this.triger) {
            this.popup.dataset.open = "false";
            this.triger.forEach((item)=>{
                item.dataset.open = "false", item.classList.remove("activeClass", "jsPopupOpen");
            });
            this.popup.classList.remove("activeClass", "jsPopupOpen");
        }
    }
    overlayClose() {
        this.overlay?.addEventListener("click", ()=>{
            this.isOpen = false;
            this.setOverlay();
        });
    }
    openPopup() {
        if (this.popup && this.triger) this.triger.forEach((item)=>{
            item.addEventListener("click", this.onTriggerClick.bind(this));
        });
    }
    onTriggerClick() {
        if (this.popup) {
            if (!this.isOpen) {
                this.isOpen = true;
                this.setOverlay();
                window.dispatchEvent(window.popupOpenEvent);
            } else {
                this.isOpen = false;
                this.setOverlay();
            }
        }
    }
    setOverlay() {
        if (this.popup && this.triger) {
            if (this.isOpen) {
                this.closeAll();
                this.popup.classList.add("activeClass", "jsPopupOpen");
                this.popup.dataset.open = "true";
                this.triger.forEach((item)=>{
                    item.dataset.open = "true", item.classList.add("activeClass", "jsPopupOpen");
                });
                this.overlay?.classList.add("activeClass");
                document.documentElement.style.overflow = "hidden";
                document.body.classList.add("activeClass");
            } else {
                this.popup.classList.remove("activeClass", "jsPopupOpen");
                this.popup.dataset.open = "false";
                this.triger.forEach((item)=>{
                    item.dataset.open = "false", item.classList.remove("activeClass", "jsPopupOpen");
                });
                this.overlay?.classList.remove("activeClass");
                document.documentElement.style.overflow = "auto";
                document.body.classList.remove("activeClass");
            }
        }
    }
    setClose() {
        this.close?.forEach((item)=>{
            item.addEventListener("click", ()=>{
                this.isOpen = false;
                this.setOverlay();
            });
        });
    }
    resetSlider() {
        window.addEventListener("closePopups", ()=>{
            this.closeAll();
        });
    }
    closeAll() {
        const popups = document.querySelectorAll(".jsPopupOpen");
        this.overlay?.classList.remove("activeClass");
        document.documentElement.style.overflow = "auto";
        document.body.classList.remove("activeClass");
        window.dispatchEvent(window.popupsClosedEvent);
        popups.forEach((item)=>{
            item.classList.remove("activeClass", "jsPopupOpen");
            item.dataset.open = "false";
        });
    }
}


const $c11f0a32cd89d9db$var$helpMob = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsHelpWrap", "#jsOpenMobHelp", "#jsCloseHelp");
$c11f0a32cd89d9db$var$helpMob.init();
const $c11f0a32cd89d9db$var$mobMenu = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsMenuWrap", "#jsOpenMenu", "#jsCloseMenu");
$c11f0a32cd89d9db$var$mobMenu.init();
const $c11f0a32cd89d9db$var$user = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsUserWrap", "#jsOpenUser", "#jsCloseUser");
$c11f0a32cd89d9db$var$user.init();
const $c11f0a32cd89d9db$var$cart = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsCartWrap", "#jsOpenCart", "#jsCloseCart");
$c11f0a32cd89d9db$var$cart.init();
const $c11f0a32cd89d9db$var$finderMob = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsFinderWrap", "#jsOpenMobFinder", "#jsCloseFinder");
$c11f0a32cd89d9db$var$finderMob.init();
const $c11f0a32cd89d9db$var$finderDesk = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsFinderWrap", "#jsOpenDeskFinder", "#jsCloseFinder");
$c11f0a32cd89d9db$var$finderDesk.init();
const $c11f0a32cd89d9db$var$filter = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsFilterWrap", "#jsOpenFilter", "#jsCloseFilter");
$c11f0a32cd89d9db$var$filter.init();
function $c11f0a32cd89d9db$var$initEnquiryPopup() {
    const enquire = new (0, $5faf9ae567940230$export$129a32eedafa97c5)("#jsEnquiryWrap", ".jsOpenEnquiry", "#jsCloseEnquiry");
    enquire.init();
}
$c11f0a32cd89d9db$var$initEnquiryPopup();
window.addEventListener("reset", ()=>{
    requestAnimationFrame(()=>{
        $c11f0a32cd89d9db$var$initEnquiryPopup();
    });
});


(0, $33151c6d3bf6cc96$export$f531f92e2a15358f)();
(0, $33151c6d3bf6cc96$export$4a59b34ae617836)();
(0, $c2451cd7f9fe8fd7$export$2e2bcd8739ae039).init();
(0, $d4e2d81e80d5910a$export$2e2bcd8739ae039).init();
(0, $314b550233ac0c7d$export$2e2bcd8739ae039).init();
(0, $61e60b05d877614a$export$2e2bcd8739ae039).init();
(0, $0d2d2f0cba207d42$export$2e2bcd8739ae039).init();
(0, $1930f24e3c858708$export$2e2bcd8739ae039).init();
(0, $fecaf8c6db57680a$export$2e2bcd8739ae039).init();
(0, $66a6452774c8b5f2$export$2e2bcd8739ae039).init();
(0, $69333880e753ba80$export$2e2bcd8739ae039).init();
(0, $7f7b779d59f7c599$export$2e2bcd8739ae039).init();
(0, $38b4613e8924b4cd$export$2e2bcd8739ae039).init();
(0, $7908104f9fbf8ae1$export$2e2bcd8739ae039).init();
(0, $ef8c1b6e7434ea63$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
